<template>
  <section>
    <ModalTabVideos
      :instructionalVideos="instructionalVideosByTab"
      :timer="false"
      ref="modalTabVideosSideBar"
    >
    </ModalTabVideos>

    <modal-confirm-action
      refModal='changeMode'
      idModal='changeMode'
      :loading='loading'
      :description='description'
      :title='title'
      @confirmed='setImportedToFalseCompanyLegalConsultation'
    />

    <FispqUploadAndReadModal></FispqUploadAndReadModal>
    <fispqUploadAndRegisterChemicalAgentsModal></fispqUploadAndRegisterChemicalAgentsModal>

    <b-modal
      scrollable
      ref='filter'
      id='filter'
      hide-footer
      hide-header
      header-bg-variant='info'
      header-text-variant='light'
      title='Pesquisar meus agentes adicionados'
      size='xl'
      @show='showModal()'
    >
      <b-modal
        scrollable
        :no-close-on-esc="loadingConfirmation"
        :no-close-on-backdrop="loadingConfirmation"
        ref='filter-confirmation'
        id='filter-confirmation'
        hide-footer
        hide-header
        header-bg-variant='info'
        header-text-variant='light'
        size='xl'
        @show='showModalConfirmation()'
      >
        <b-overlay
          :show="loadingConfirmation"
          rounded
          opacity="0.7"
          spinner-small
          spinner-variant="primary"
          class="d-inline-block w-100"
        >
          <section class='modal-font-family accordion'>
            <section class='header d-flex justify-content-between align-items-center mb-4'>
              <span class='title'>Confirmação de filtros aplicados</span>
              <b-icon
                @click='closeModalConfirmation()'
                class='cursor-pointer'
                font-scale='2.2'
                icon='x'
                color='#022245'
              >
              </b-icon>
            </section>

            <section v-if='products.length > 0 && selectedProducts.length > 0' class='mt-4 filter-product p-3 transition'>
              <section>
                <section class="">
                  <section class="pr-2 mb-2">
                    <p class='title-product mb-0 pb-0'>Selecione os produtos que você deseja mostrar</p>
                    <span class="title-quantity-product">
                      Itens selecionados:
                    </span>
                  </section>

                  <section
                    style='display: flex; flex-wrap: wrap'
                  >
                    <b-form-checkbox-group
                      v-for='(product, i) in products.filter(x => selectedProducts.includes(x._id))'
                      v-model='selectedProducts'
                      :key='i'
                      class=''
                      stacked
                    >
                      <b-form-checkbox
                        :value='product._id'
                        disabled
                        class="mr-4"
                      >
                            <span
                              class='text'
                            >
                              {{ product.name }}
                            </span>
                      </b-form-checkbox>
                    </b-form-checkbox-group>
                  </section>
                </section>
              </section>
            </section>

            <section v-if='filtroNormativoSelecionado' class='mt-4 filter-product p-3 transition'>
              <section>
                <section class="">
                  <section class="pr-2 mb-2">
                    <p class='title-product mb-0 pb-0'>Filtro de Normativas</p>
                    <span class="title-quantity-product">
                      Itens selecionados:
                    </span>
                  </section>

                  <section class="d-flex align-items-center" v-if="mostrarFiltroNormativoSelecionado">
                    <section class="d-flex align-items-center flex-wrap" v-if="filters.typeFilterAgents === accumulatedFilter">
                      <!--ACGIH-->
                      <section class="mr-4" v-if="acgihAccumulateddFilter && acgihAccumulateddFilter.length > 0 && acgihAccumulateddFilter.includes('consta')">
                        <b-form-checkbox
                          id="acgihAccumulateddFilterConsta"
                          v-model="acgihAccumulateddFilter"
                          name="acgihAccumulateddFilterConsta"
                          disabled
                          value="consta"
                          button-variant="primary"
                        >
                          <span class='text-filter-applied'>ACGIH Consta</span>
                          <img
                            class='ml-1 mb-1'
                            width='13'
                            height='12'
                            v-bind:src='require(`../../../assets/images/consta.svg`)' alt=''
                          />
                        </b-form-checkbox>
                      </section>

                      <section class="mr-4" v-if="acgihAccumulateddFilter && acgihAccumulateddFilter.length > 0 && acgihAccumulateddFilter.includes('naoConsta')">
                        <b-form-checkbox
                          id="acgihAccumulateddFilterNaoConsta"
                          v-model="acgihAccumulateddFilter"
                          name="acgihAccumulateddFilterNaoConsta"
                          disabled
                          value="naoConsta"
                          button-variant="primary"
                        >
                          <span class='text-filter-applied'>ACGIH Não consta</span>
                          <img
                            class='ml-1 mb-1'
                            width='13'
                            height='12'
                            v-bind:src='require(`../../../assets/images/naoConsta.svg`)' alt=''
                          />
                        </b-form-checkbox>
                      </section>

                      <!--NR 15-->
                      <section class="mr-4" v-if="nr15AccumulatedFilter && nr15AccumulatedFilter.length > 0 && nr15AccumulatedFilter.includes('consta')">
                        <b-form-checkbox
                          id="nr15AccumulatedFilterConsta"
                          v-model="nr15AccumulatedFilter"
                          name="nr15AccumulatedFilterConsta"
                          disabled
                          value="consta"
                          button-variant="primary"
                        >
                          <span class='text-filter-applied'>NR 15 Consta</span>
                          <img
                            class='ml-1 mb-1'
                            width='13'
                            height='12'
                            v-bind:src='require(`../../../assets/images/consta.svg`)' alt=''
                          />
                        </b-form-checkbox>
                      </section>

                      <section class="mr-4" v-if="nr15AccumulatedFilter && nr15AccumulatedFilter.length > 0 && nr15AccumulatedFilter.includes('naoConsta')">
                        <b-form-checkbox
                          id="nr15AccumulatedFilterNaoConsta"
                          v-model="nr15AccumulatedFilter"
                          name="nr15AccumulatedFilterNaoConsta"
                          disabled
                          value="naoConsta"
                          button-variant="primary"
                        >
                          <span class='text-filter-applied'>NR 15 Não consta</span>
                          <img
                            class='ml-1 mb-1'
                            width='13'
                            height='12'
                            v-bind:src='require(`../../../assets/images/naoConsta.svg`)' alt=''
                          />
                        </b-form-checkbox>
                      </section>

                      <section class="mr-4" v-if="nr15AccumulatedFilter && nr15AccumulatedFilter.length > 0 && nr15AccumulatedFilter.includes('classificacao')">
                        <b-form-checkbox
                          id="nr15AccumulatedFilterClassificacao"
                          v-model="nr15AccumulatedFilter"
                          name="nr15AccumulatedFilterClassificacao"
                          disabled
                          value="classificacao"
                          button-variant="primary"
                        >
                          <span class='text-filter-applied'>NR 15 Em classificação</span>
                          <img
                            class='ml-1 mb-1'
                            width='13'
                            height='12'
                            v-bind:src='require(`../../../assets/images/classificacao.svg`)' alt=''
                          />
                        </b-form-checkbox>
                      </section>


                      <!--LINACH-->
                      <section class="mr-4" v-if="linachAccumulatedFilter && linachAccumulatedFilter.length > 0 && linachAccumulatedFilter.includes('consta')">
                        <b-form-checkbox
                          id="linachAccumulatedFilterConsta"
                          v-model="linachAccumulatedFilter"
                          name="linachAccumulatedFilterConsta"
                          disabled
                          value="consta"
                          button-variant="primary"
                        >
                          <span class='text-filter-applied'>LINACH Consta</span>
                          <img
                            class='ml-1 mb-1'
                            width='13'
                            height='12'
                            v-bind:src='require(`../../../assets/images/consta.svg`)' alt=''
                          />
                        </b-form-checkbox>
                      </section>

                      <section class="mr-4" v-if="linachAccumulatedFilter && linachAccumulatedFilter.length > 0 && linachAccumulatedFilter.includes('naoConsta')">
                        <b-form-checkbox
                          id="linachAccumulatedFilterNaoConsta"
                          v-model="linachAccumulatedFilter"
                          name="linachAccumulatedFilterNaoConsta"
                          disabled
                          value="naoConsta"
                          button-variant="primary"
                        >
                          <span class='text-filter-applied'>LINACH Não consta</span>
                          <img
                            class='ml-1 mb-1'
                            width='13'
                            height='12'
                            v-bind:src='require(`../../../assets/images/naoConsta.svg`)' alt=''
                          />
                        </b-form-checkbox>
                      </section>


                      <!--ESOCIAL - Tabela 24-->
                      <section class="mr-4" v-if="esocialAccumulatedFilter && esocialAccumulatedFilter.length > 0 && esocialAccumulatedFilter.includes('consta')">
                        <b-form-checkbox
                          id="esocialAccumulatedFilterConsta"
                          v-model="esocialAccumulatedFilter"
                          name="esocialAccumulatedFilterConsta"
                          disabled
                          value="consta"
                          button-variant="primary"
                        >
                          <span class='text-filter-applied'>ESOCIAL - Tabela 24 Consta</span>
                          <img
                            class='ml-1 mb-1'
                            width='13'
                            height='12'
                            v-bind:src='require(`../../../assets/images/consta.svg`)' alt=''
                          />
                        </b-form-checkbox>
                      </section>

                      <section class="mr-4" v-if="esocialAccumulatedFilter && esocialAccumulatedFilter.length > 0 && esocialAccumulatedFilter.includes('naoConsta')">
                        <b-form-checkbox
                          id="esocialAccumulatedFilterNaoConsta"
                          v-model="esocialAccumulatedFilter"
                          name="esocialAccumulatedFilterNaoConsta"
                          disabled
                          value="naoConsta"
                          button-variant="primary"
                        >
                          <span class='text-filter-applied'>ESOCIAL - Tabela 24 Não consta</span>
                          <img
                            class='ml-1 mb-1'
                            width='13'
                            height='12'
                            v-bind:src='require(`../../../assets/images/naoConsta.svg`)' alt=''
                          />
                        </b-form-checkbox>
                      </section>

                      <section class="mr-4" v-if="esocialAccumulatedFilter && esocialAccumulatedFilter.length > 0 && esocialAccumulatedFilter.includes('classificacao')">
                        <b-form-checkbox
                          id="esocialAccumulatedFilterClassificacao"
                          v-model="esocialAccumulatedFilter"
                          name="esocialAccumulatedFilterClassificacao"
                          disabled
                          value="classificacao"
                          button-variant="primary"
                        >
                          <span class='text-filter-applied'>ESOCIAL - Tabela 24 Em classificação</span>
                          <img
                            class='ml-1 mb-1'
                            width='13'
                            height='12'
                            v-bind:src='require(`../../../assets/images/classificacao.svg`)' alt=''
                          />
                        </b-form-checkbox>
                      </section>


                      <!--DECRETO 3048/99 - Anexo IV-->
                      <section class="mr-4" v-if="decretoAccumulatedFilter && decretoAccumulatedFilter.length > 0 && decretoAccumulatedFilter.includes('consta')">
                        <b-form-checkbox
                          id="decretoAccumulatedFilterConsta"
                          v-model="decretoAccumulatedFilter"
                          name="decretoAccumulatedFilterConsta"
                          disabled
                          value="consta"
                          button-variant="primary"
                        >
                          <span class='text-filter-applied'>DECRETO 3048/99 - Anexo IV Consta</span>
                          <img
                            class='ml-1 mb-1'
                            width='13'
                            height='12'
                            v-bind:src='require(`../../../assets/images/consta.svg`)' alt=''
                          />
                        </b-form-checkbox>
                      </section>

                      <section class="mr-2" v-if="decretoAccumulatedFilter && decretoAccumulatedFilter.length > 0 && decretoAccumulatedFilter.includes('naoConsta')">
                        <b-form-checkbox
                          id="decretoAccumulatedFilterNaoConsta"
                          v-model="decretoAccumulatedFilter"
                          name="decretoAccumulatedFilterNaoConsta"
                          disabled
                          value="naoConsta"
                          button-variant="primary"
                        >
                          <span class='text-filter-applied'>DECRETO 3048/99 - Anexo IV Não consta</span>
                          <img
                            class='ml-1 mb-1'
                            width='13'
                            height='12'
                            v-bind:src='require(`../../../assets/images/naoConsta.svg`)' alt=''
                          />
                        </b-form-checkbox>
                      </section>

                      <section class="mr-2" v-if="decretoAccumulatedFilter && decretoAccumulatedFilter.length > 0 && decretoAccumulatedFilter.includes('classificacao')">
                        <b-form-checkbox
                          id="decretoAccumulatedFilterClassificacao"
                          v-model="decretoAccumulatedFilter"
                          name="decretoAccumulatedFilterClassificacao"
                          disabled
                          value="classificacao"
                          button-variant="primary"
                        >
                          <span class='text-filter-applied'>DECRETO 3048/99 - Anexo IV Em classificação</span>
                          <img
                            class='ml-1 mb-1'
                            width='13'
                            height='12'
                            v-bind:src='require(`../../../assets/images/classificacao.svg`)' alt=''
                          />
                        </b-form-checkbox>
                      </section>
                    </section>

                    <section class="d-flex align-items-center flex-wrap" v-else>
                      <!--ACGIH-->
                      <section class="mr-4" v-if="acgih && acgih.length > 0 && acgih.includes('consta')">
                        <b-form-checkbox
                          id="acgihConsta"
                          v-model="acgih"
                          name="acgihConsta"
                          disabled
                          value="consta"
                          button-variant="primary"
                        >
                          <span class='text-filter-applied'>ACGIH Consta</span>
                          <img
                            class='ml-1 mb-1'
                            width='13'
                            height='12'
                            v-bind:src='require(`../../../assets/images/consta.svg`)' alt=''
                          />
                        </b-form-checkbox>
                      </section>

                      <section class="mr-4" v-if="acgih && acgih.length > 0 && acgih.includes('naoConsta')">
                        <b-form-checkbox
                          id="acgihNaoConsta"
                          v-model="acgih"
                          name="acgihNaoConsta"
                          disabled
                          value="naoConsta"
                          button-variant="primary"
                        >
                          <span class='text-filter-applied'>ACGIH Não consta</span>
                          <img
                            class='ml-1 mb-1'
                            width='13'
                            height='12'
                            v-bind:src='require(`../../../assets/images/naoConsta.svg`)' alt=''
                          />
                        </b-form-checkbox>
                      </section>

                      <!--NR 15-->
                      <section class="mr-4" v-if="nr15 && nr15.length > 0 && nr15.includes('consta')">
                        <b-form-checkbox
                          id="nr15Consta"
                          v-model="nr15"
                          name="nr15Consta"
                          disabled
                          value="consta"
                          button-variant="primary"
                        >
                          <span class='text-filter-applied'>NR 15 Consta</span>
                          <img
                            class='ml-1 mb-1'
                            width='13'
                            height='12'
                            v-bind:src='require(`../../../assets/images/consta.svg`)' alt=''
                          />
                        </b-form-checkbox>
                      </section>

                      <section class="mr-4" v-if="nr15 && nr15.length > 0 && nr15.includes('naoConsta')">
                        <b-form-checkbox
                          id="nr15NaoConsta"
                          v-model="nr15"
                          name="nr15NaoConsta"
                          disabled
                          value="naoConsta"
                          button-variant="primary"
                        >
                          <span class='text-filter-applied'>NR 15 Não consta</span>
                          <img
                            class='ml-1 mb-1'
                            width='13'
                            height='12'
                            v-bind:src='require(`../../../assets/images/naoConsta.svg`)' alt=''
                          />
                        </b-form-checkbox>
                      </section>

                      <section class="mr-4" v-if="nr15 && nr15.length > 0 && nr15.includes('classificacao')">
                        <b-form-checkbox
                          id="nr15Classificacao"
                          v-model="nr15"
                          name="nr15Classificacao"
                          disabled
                          value="classificacao"
                          button-variant="primary"
                        >
                          <span class='text-filter-applied'>NR 15 Em classificação</span>
                          <img
                            class='ml-1 mb-1'
                            width='13'
                            height='12'
                            v-bind:src='require(`../../../assets/images/classificacao.svg`)' alt=''
                          />
                        </b-form-checkbox>
                      </section>


                      <!--LINACH-->
                      <section class="mr-4" v-if="linach && linach.length > 0 && linach.includes('consta')">
                        <b-form-checkbox
                          id="nr15Consta"
                          v-model="linach"
                          name="nr15Consta"
                          disabled
                          value="consta"
                          button-consta="primary"
                        >
                          <span class='text-filter-applied'>LINACH Consta</span>
                          <img
                            class='ml-1 mb-1'
                            width='13'
                            height='12'
                            v-bind:src='require(`../../../assets/images/consta.svg`)' alt=''
                          />
                        </b-form-checkbox>
                      </section>

                      <section class="mr-4" v-if="linach && linach.length > 0 && linach.includes('naoConsta')">
                        <b-form-checkbox
                          id="nr15NaoConsta"
                          v-model="linach"
                          name="nr15NaoConsta"
                          disabled
                          value="naoConsta"
                          button-consta="primary"
                        >
                          <span class='text-filter-applied'>LINACH Não consta</span>
                          <img
                            class='ml-1 mb-1'
                            width='13'
                            height='12'
                            v-bind:src='require(`../../../assets/images/naoConsta.svg`)' alt=''
                          />
                        </b-form-checkbox>
                      </section>


                      <!--ESOCIAL - Tabela 24-->
                      <section class="mr-4" v-if="esocial && esocial.length > 0 && esocial.includes('consta')">
                        <b-form-checkbox
                          id="esocialConsta"
                          v-model="esocial"
                          name="esocialConsta"
                          disabled
                          value="consta"
                          button-consta="primary"
                        >
                          <span class='text-filter-applied'>ESOCIAL - Tabela 24 Consta</span>
                          <img
                            class='ml-1 mb-1'
                            width='13'
                            height='12'
                            v-bind:src='require(`../../../assets/images/consta.svg`)' alt=''
                          />
                        </b-form-checkbox>
                      </section>

                      <section class="mr-4" v-if="esocial && esocial.length > 0 && esocial.includes('naoConsta')">
                        <b-form-checkbox
                          id="esocialNaoConsta"
                          v-model="linach"
                          name="esocialNaoConsta"
                          disabled
                          value="naoConsta"
                          button-consta="primary"
                        >
                          <span class='text-filter-applied'>ESOCIAL - Tabela 24 Não consta</span>
                          <img
                            class='ml-1 mb-1'
                            width='13'
                            height='12'
                            v-bind:src='require(`../../../assets/images/naoConsta.svg`)' alt=''
                          />
                        </b-form-checkbox>
                      </section>

                      <section class="mr-4" v-if="esocial && esocial.length > 0 && esocial.includes('classificacao')">
                        <b-form-checkbox
                          id="esocialClassificacao"
                          v-model="linach"
                          name="esocialClassificacao"
                          disabled
                          value="classificacao"
                          button-consta="primary"
                        >
                          <span class='text-filter-applied'>ESOCIAL - Tabela 24 Em classificação</span>
                          <img
                            class='ml-1 mb-1'
                            width='13'
                            height='12'
                            v-bind:src='require(`../../../assets/images/classificacao.svg`)' alt=''
                          />
                        </b-form-checkbox>
                      </section>


                      <!--DECRETO 3048/99 - Anexo IV-->
                      <section class="mr-4" v-if="decreto && decreto.length > 0 && decreto.includes('consta')">
                        <b-form-checkbox
                          id="decretoConsta"
                          v-model="decreto"
                          name="decretoConsta"
                          disabled
                          value="consta"
                          button-consta="primary"
                        >
                          <span class='text-filter-applied'>DECRETO 3048/99 - Anexo IV Consta</span>
                          <img
                            class='ml-1 mb-1'
                            width='13'
                            height='12'
                            v-bind:src='require(`../../../assets/images/consta.svg`)' alt=''
                          />
                        </b-form-checkbox>
                      </section>

                      <section class="mr-4" v-if="decreto && decreto.length > 0 && decreto.includes('naoConsta')">
                        <b-form-checkbox
                          id="decretoNaoConsta"
                          v-model="decreto"
                          name="decretoNaoConsta"
                          disabled
                          value="naoConsta"
                          button-consta="primary"
                        >
                          <span class='text-filter-applied'>DECRETO 3048/99 - Anexo IV Não consta</span>
                          <img
                            class='ml-1 mb-1'
                            width='13'
                            height='12'
                            v-bind:src='require(`../../../assets/images/naoConsta.svg`)' alt=''
                          />
                        </b-form-checkbox>
                      </section>

                      <section class="mr-4" v-if="decreto && decreto.length > 0 && decreto.includes('classificacao')">
                        <b-form-checkbox
                          id="decretoClassificacao"
                          v-model="decreto"
                          name="decretoClassificacao"
                          disabled
                          value="classificacao"
                          button-consta="primary"
                        >
                          <span class='text-filter-applied'>DECRETO 3048/99 - Anexo IV Em classificação</span>
                          <img
                            class='ml-1 mb-1'
                            width='13'
                            height='12'
                            v-bind:src='require(`../../../assets/images/classificacao.svg`)' alt=''
                          />
                        </b-form-checkbox>
                      </section>

                    </section>
                  </section>
                </section>
              </section>
            </section>

            <section v-if='filterForwardedAgentsSelected.length > 0' class='mt-4 filter-product p-3 transition'>
              <section>
                <section class="">
                  <section class="pr-2 mb-2">
                    <p class='title-product mb-0 pb-0'>Filtrar agentes repetidos</p>
                    <span class="title-quantity-product">
                      Itens selecionados:
                    </span>
                  </section>

                  <section
                    style='display: flex; flex-wrap: wrap'
                  >
                    <section class="mr-4" v-if="filterForwardedAgentsSelected && filterForwardedAgentsSelected.length > 0 && filterForwardedAgentsSelected.includes('SHOW_ONLY_ONCE')">
                      <b-form-checkbox
                        id="filterForwardedAgentsSelectedSHOW_ONLY_ONCE"
                        v-model="filterForwardedAgentsSelected"
                        name="filterForwardedAgentsSelectedSHOW_ONLY_ONCE"
                        disabled
                        value="SHOW_ONLY_ONCE"
                        button-variant="primary"
                      >
                        <span class='text-filter-applied'>Mostrar só uma vez cada agente</span>
                      </b-form-checkbox>
                    </section>
                    <section class="mr-4" v-if="filterForwardedAgentsSelected && filterForwardedAgentsSelected.length > 0 && filterForwardedAgentsSelected.includes('SHOW_ALL')">
                      <b-form-checkbox
                        id="filterForwardedAgentsSelectedSHOW_ALL"
                        v-model="filterForwardedAgentsSelected"
                        name="filterForwardedAgentsSelectedSHOW_ALL"
                        disabled
                        value="SHOW_ALL"
                        button-variant="primary"
                      >
                        <span class='text-filter-applied'>Mostrar todos (com repetição)</span>
                      </b-form-checkbox>
                    </section>
                  </section>
                </section>
              </section>
            </section>

            <section v-if='selectedAgentsFilter.length > 0' class='mt-4 filter-product p-3 transition'>
              <section>
                <section class="">
                  <section class="pr-2 mb-2">
                    <p class='title-product mb-0 pb-0'>Filtrar por agente</p>
                    <span class="title-quantity-product">
                      Itens selecionados:
                    </span>
                  </section>

                  <section style='display: flex; flex-wrap: wrap'>
                    <b-form-checkbox-group
                      v-for='agent in agentsName.filter(x => selectedAgentsFilter.includes(x._id))'
                      v-model='selectedAgentsFilter'
                      :key='agent._id'
                      stacked
                    >
                      <b-form-checkbox
                        :value='agent._id'
                        disabled
                        class="mr-4"
                      >
                        <span class='text'>{{ agent.name }}</span>
                      </b-form-checkbox>
                    </b-form-checkbox-group>
                  </section>
                </section>
              </section>
            </section>

            <section class='d-flex justify-content-end mt-3 w-100'>
              <base-button
                class='btn-clear-filter w-25 mr-3'
                @click='closeModalConfirmation()'
              >
                <span>Cancelar</span>
              </base-button>

              <base-button
                class='btn_filter w-75'
                @click='searchAgents()'
              >
                <span>Confirmar aplicação de filtros</span>
              </base-button>
            </section>
          </section>

          <template #overlay>
            <div class="text-center">
              <b-spinner
                style="width: 3rem; height: 3rem;"
                variant="info"
                label="Spinning">
              </b-spinner>
              <h5 class=''>Buscando...</h5>
            </div>
          </template>
        </b-overlay>
      </b-modal>


      <section class='modal-font-family accordion'>
        <section class='header d-flex justify-content-between align-items-center mb-4'>
          <span class='title'>Pesquisar meus agentes adicionados</span>
          <b-icon
            @click='closeModal()'
            class='cursor-pointer'
            font-scale='2.2'
            icon='x'
            color='#022245'
          >
          </b-icon>
        </section>

        <section v-if='products.length > 0' class='mt-4 filter-product p-3 transition'>
          <section>
            <section class="d-flex justify-content-between align-items-center">
              <section class="pr-2">
                <p class='title-product mb-0 pb-0'>Selecione os produtos que você deseja mostrar</p>
                <span
                  v-if="!selectedProducts || selectedProducts.length <= 0"
                  class="title-quantity-product"
                >
                {{products.length}} {{products.length > 1 ? 'opções' : 'opção'}}
              </span>
              </section>

              <section class="d-flex justify-content-between align-items-center">
                <section class="mr-2">
                  <section
                    class='product'
                    style="min-width: 170px"
                    v-if="filterProduct"
                  >
                    <b-form-checkbox
                      id="selectAll"
                      v-model="selectAll"
                      name="selectAll"
                      :value="true"
                      :unchecked-value="false"
                      @change="setSelectAll"
                    >
                      <span
                        class='text'
                      >
                          Selecionar todos
                        </span>
                    </b-form-checkbox>
                  </section>
                </section>
                <section>
                  <b-icon
                    @click="filterProduct = !filterProduct"
                    font-scale='2'
                    icon='chevron-down'
                    color='#262626'
                    class='cursor-pointer transition'
                    v-if="filterProduct"
                  >
                  </b-icon>
                  <b-icon
                    v-else
                    @click="filterProduct = !filterProduct"
                    font-scale='2'
                    icon='chevron-right'
                    color='#262626'
                    class='cursor-pointer transition'
                  >
                  </b-icon>
                </section>
              </section>
            </section>

            <section>
              <span
                v-if="selectedProducts && selectedProducts.length > 0"
                class="selected-products"
              >
                <span>Itens selecionados: </span>{{products.filter(x => selectedProducts.includes(x._id)).map(x => x.name).join(', ')}}
              </span>
            </section>
          </section>

          <section
            v-if="filterProduct"
            class="transition"
          >
            <section class="my-3">
              <button class="btn-selected w-100 ">
                <span>Filtro acumulado</span>
              </button>
            </section>

            <section
              style='display: grid;  grid-template-columns: repeat(auto-fill, minmax(32%, 1fr)); gap: 10px'
            >
              <b-form-checkbox-group
                v-for='(product, i) in products'
                v-model='selectedProducts'
                :key='i'
                class=''
                stacked
              >
                <section
                  class='product'
                >
                  <b-form-checkbox
                    button-variant="info"
                    :value='product._id'
                  >
                    <span
                      class='text'
                      :style="selectedProducts.includes(product._id) ? 'color: #022245;font-weight: 700;': 'color: #262626; font-weight: 400;'"
                    >
                      Produto: {{ product.name }} <br/>
                      <span v-if="product.role && product.role.name">Cargo: {{product.role.name}}</span>
                    </span>
                  </b-form-checkbox>
                </section>
              </b-form-checkbox-group>
            </section>
          </section>
        </section>

        <section v-if='products.length > 0' class='mt-4'>
          <hr/>
        </section>

        <section class="filter-normativas p-3">
          <section>
            <section class="d-flex justify-content-between align-items-center">
              <section>
                <p class='title-product  mb-0 pb-0'><strong>Filtro de Normativas</strong></p>
                <span v-if="!filtroNormativoSelecionado" class="title-quantity-product">13 opções</span>
              </section>

              <section class="d-flex justify-content-between align-items-center">
                <b-icon
                  @click="filterNormativa = !filterNormativa"
                  font-scale='2'
                  icon='chevron-down'
                  color='#262626'
                  class='cursor-pointer transition'
                  v-if="filterNormativa"
                >
                </b-icon>
                <b-icon
                  v-else
                  @click="filterNormativa = !filterNormativa"
                  font-scale='2'
                  icon='chevron-right'
                  color='#262626'
                  class='cursor-pointer transition'
                >
                </b-icon>
              </section>
            </section>

            <section class="d-flex align-items-center" v-if="filtroNormativoSelecionado">
              <section class="d-flex align-items-center flex-wrap" v-if="filters.typeFilterAgents === accumulatedFilter">
                <section>
                  <span class='text-filter-applied mr-2'>Itens selecionados:</span>
                </section>
                <!--ACGIH-->
                <section class="mr-2" v-if="acgihAccumulateddFilter && acgihAccumulateddFilter.length > 0 && acgihAccumulateddFilter.includes('consta')">
                  <span class='text-filter-applied'>ACGIH Consta</span>
                  <img
                    class='ml-1 mb-1'
                    width='13'
                    height='12'
                    v-bind:src='require(`../../../assets/images/consta.svg`)' alt=''
                  />,
                </section>

                <section class="mr-2" v-if="acgihAccumulateddFilter && acgihAccumulateddFilter.length > 0 && acgihAccumulateddFilter.includes('naoConsta')">
                  <span class='text-filter-applied'>ACGIH Não consta</span>
                  <img
                    class='ml-1 mb-1'
                    width='13'
                    height='12'
                    v-bind:src='require(`../../../assets/images/naoConsta.svg`)' alt=''
                  />,
                </section>

                <!--NR 15-->
                <section class="mr-2" v-if="nr15AccumulatedFilter && nr15AccumulatedFilter.length > 0 && nr15AccumulatedFilter.includes('consta')">
                  <span class='text-filter-applied'>NR 15 Consta</span>
                  <img
                    class='ml-1 mb-1'
                    width='13'
                    height='12'
                    v-bind:src='require(`../../../assets/images/consta.svg`)' alt=''
                  />,
                </section>

                <section class="mr-2" v-if="nr15AccumulatedFilter && nr15AccumulatedFilter.length > 0 && nr15AccumulatedFilter.includes('naoConsta')">
                  <span class='text-filter-applied'>NR 15 Não consta</span>
                  <img
                    class='ml-1 mb-1'
                    width='13'
                    height='12'
                    v-bind:src='require(`../../../assets/images/naoConsta.svg`)' alt=''
                  />,
                </section>

                <section class="mr-2" v-if="nr15AccumulatedFilter && nr15AccumulatedFilter.length > 0 && nr15AccumulatedFilter.includes('classificacao')">
                  <span class='text-filter-applied'>NR 15 Em classificação</span>
                  <img
                    class='ml-1 mb-1'
                    width='13'
                    height='12'
                    v-bind:src='require(`../../../assets/images/classificacao.svg`)' alt=''
                  />,
                </section>


                <!--LINACH-->
                <section class="mr-2" v-if="linachAccumulatedFilter && linachAccumulatedFilter.length > 0 && linachAccumulatedFilter.includes('consta')">
                  <span class='text-filter-applied'>LINACH Consta</span>
                  <img
                    class='ml-1 mb-1'
                    width='13'
                    height='12'
                    v-bind:src='require(`../../../assets/images/consta.svg`)' alt=''
                  />,
                </section>

                <section class="mr-2" v-if="linachAccumulatedFilter && linachAccumulatedFilter.length > 0 && linachAccumulatedFilter.includes('naoConsta')">
                  <span class='text-filter-applied'>LINACH Não consta</span>
                  <img
                    class='ml-1 mb-1'
                    width='13'
                    height='12'
                    v-bind:src='require(`../../../assets/images/naoConsta.svg`)' alt=''
                  />,
                </section>


                <!--ESOCIAL - Tabela 24-->
                <section class="mr-2" v-if="esocialAccumulatedFilter && esocialAccumulatedFilter.length > 0 && esocialAccumulatedFilter.includes('consta')">
                  <span class='text-filter-applied'>ESOCIAL - Tabela 24 Consta</span>
                  <img
                    class='ml-1 mb-1'
                    width='13'
                    height='12'
                    v-bind:src='require(`../../../assets/images/consta.svg`)' alt=''
                  />,
                </section>

                <section class="mr-2" v-if="esocialAccumulatedFilter && esocialAccumulatedFilter.length > 0 && esocialAccumulatedFilter.includes('naoConsta')">
                  <span class='text-filter-applied'>ESOCIAL - Tabela 24 Não consta</span>
                  <img
                    class='ml-1 mb-1'
                    width='13'
                    height='12'
                    v-bind:src='require(`../../../assets/images/naoConsta.svg`)' alt=''
                  />,
                </section>

                <section class="mr-2" v-if="esocialAccumulatedFilter && esocialAccumulatedFilter.length > 0 && esocialAccumulatedFilter.includes('classificacao')">
                  <span class='text-filter-applied'>ESOCIAL - Tabela 24 Em classificação</span>
                  <img
                    class='ml-1 mb-1'
                    width='13'
                    height='12'
                    v-bind:src='require(`../../../assets/images/classificacao.svg`)' alt=''
                  />,
                </section>


                <!--DECRETO 3048/99 - Anexo IV-->
                <section class="mr-2" v-if="decretoAccumulatedFilter && decretoAccumulatedFilter.length > 0 && decretoAccumulatedFilter.includes('consta')">
                  <span class='text-filter-applied'>DECRETO 3048/99 - Anexo IV Consta</span>
                  <img
                    class='ml-1 mb-1'
                    width='13'
                    height='12'
                    v-bind:src='require(`../../../assets/images/consta.svg`)' alt=''
                  />,
                </section>

                <section class="mr-2" v-if="decretoAccumulatedFilter && decretoAccumulatedFilter.length > 0 && decretoAccumulatedFilter.includes('naoConsta')">
                  <span class='text-filter-applied'>DECRETO 3048/99 - Anexo IV Não consta</span>
                  <img
                    class='ml-1 mb-1'
                    width='13'
                    height='12'
                    v-bind:src='require(`../../../assets/images/naoConsta.svg`)' alt=''
                  />,
                </section>

                <section class="mr-2" v-if="decretoAccumulatedFilter && decretoAccumulatedFilter.length > 0 && decretoAccumulatedFilter.includes('classificacao')">
                  <span class='text-filter-applied'>DECRETO 3048/99 - Anexo IV Em classificação</span>
                  <img
                    class='ml-1 mb-1'
                    width='13'
                    height='12'
                    v-bind:src='require(`../../../assets/images/classificacao.svg`)' alt=''
                  />,
                </section>
              </section>
              <section class="d-flex align-items-center flex-wrap" v-else>
                <section>
                  <span class='text-filter-applied mr-2'>Itens selecionados:</span>
                </section>
                <!--ACGIH-->
                <section class="mr-2" v-if="acgih && acgih.length > 0 && acgih.includes('consta')">
                  <span class='text-filter-applied'>ACGIH Consta</span>
                  <img
                    class='ml-1 mb-1'
                    width='13'
                    height='12'
                    v-bind:src='require(`../../../assets/images/consta.svg`)' alt=''
                  />,
                </section>

                <section class="mr-2" v-if="acgih && acgih.length > 0 && acgih.includes('naoConsta')">
                  <span class='text-filter-applied'>ACGIH Não consta</span>
                  <img
                    class='ml-1 mb-1'
                    width='13'
                    height='12'
                    v-bind:src='require(`../../../assets/images/naoConsta.svg`)' alt=''
                  />,
                </section>

                <!--NR 15-->
                <section class="mr-2" v-if="nr15 && nr15.length > 0 && nr15.includes('consta')">
                  <span class='text-filter-applied'>NR 15 Consta</span>
                  <img
                    class='ml-1 mb-1'
                    width='13'
                    height='12'
                    v-bind:src='require(`../../../assets/images/consta.svg`)' alt=''
                  />,
                </section>

                <section class="mr-2" v-if="nr15 && nr15.length > 0 && nr15.includes('naoConsta')">
                  <span class='text-filter-applied'>NR 15 Não consta</span>
                  <img
                    class='ml-1 mb-1'
                    width='13'
                    height='12'
                    v-bind:src='require(`../../../assets/images/naoConsta.svg`)' alt=''
                  />,
                </section>

                <section class="mr-2" v-if="nr15 && nr15.length > 0 && nr15.includes('classificacao')">
                  <span class='text-filter-applied'>NR 15 Em classificação</span>
                  <img
                    class='ml-1 mb-1'
                    width='13'
                    height='12'
                    v-bind:src='require(`../../../assets/images/classificacao.svg`)' alt=''
                  />,
                </section>


                <!--LINACH-->
                <section class="mr-2" v-if="linach && linach.length > 0 && linach.includes('consta')">
                  <span class='text-filter-applied'>LINACH Consta</span>
                  <img
                    class='ml-1 mb-1'
                    width='13'
                    height='12'
                    v-bind:src='require(`../../../assets/images/consta.svg`)' alt=''
                  />,
                </section>

                <section class="mr-2" v-if="linach && linach.length > 0 && linach.includes('naoConsta')">
                  <span class='text-filter-applied'>LINACH Não consta</span>
                  <img
                    class='ml-1 mb-1'
                    width='13'
                    height='12'
                    v-bind:src='require(`../../../assets/images/naoConsta.svg`)' alt=''
                  />,
                </section>


                <!--ESOCIAL - Tabela 24-->
                <section class="mr-2" v-if="esocial && esocial.length > 0 && esocial.includes('consta')">
                  <span class='text-filter-applied'>ESOCIAL - Tabela 24 Consta</span>
                  <img
                    class='ml-1 mb-1'
                    width='13'
                    height='12'
                    v-bind:src='require(`../../../assets/images/consta.svg`)' alt=''
                  />,
                </section>

                <section class="mr-2" v-if="esocial && esocial.length > 0 && esocial.includes('naoConsta')">
                  <span class='text-filter-applied'>ESOCIAL - Tabela 24 Não consta</span>
                  <img
                    class='ml-1 mb-1'
                    width='13'
                    height='12'
                    v-bind:src='require(`../../../assets/images/naoConsta.svg`)' alt=''
                  />,
                </section>

                <section class="mr-2" v-if="esocial && esocial.length > 0 && esocial.includes('classificacao')">
                  <span class='text-filter-applied'>ESOCIAL - Tabela 24 Em classificação</span>
                  <img
                    class='ml-1 mb-1'
                    width='13'
                    height='12'
                    v-bind:src='require(`../../../assets/images/classificacao.svg`)' alt=''
                  />,
                </section>


                <!--DECRETO 3048/99 - Anexo IV-->
                <section class="mr-2" v-if="decreto && decreto.length > 0 && decreto.includes('consta')">
                  <span class='text-filter-applied'>DECRETO 3048/99 - Anexo IV Consta</span>
                  <img
                    class='ml-1 mb-1'
                    width='13'
                    height='12'
                    v-bind:src='require(`../../../assets/images/consta.svg`)' alt=''
                  />,
                </section>

                <section class="mr-2" v-if="decreto && decreto.length > 0 && decreto.includes('naoConsta')">
                  <span class='text-filter-applied'>DECRETO 3048/99 - Anexo IV Não consta</span>
                  <img
                    class='ml-1 mb-1'
                    width='13'
                    height='12'
                    v-bind:src='require(`../../../assets/images/naoConsta.svg`)' alt=''
                  />,
                </section>

                <section class="mr-2" v-if="decreto && decreto.length > 0 && decreto.includes('classificacao')">
                  <span class='text-filter-applied'>DECRETO 3048/99 - Anexo IV Em classificação</span>
                  <img
                    class='ml-1 mb-1'
                    width='13'
                    height='12'
                    v-bind:src='require(`../../../assets/images/classificacao.svg`)' alt=''
                  />,
                </section>

              </section>
            </section>
          </section>

          <section
            v-if="filterNormativa"
          >
            <section>
              <section class="my-3 d-flex w-100 ">
                <button
                  :class="filters.typeFilterAgents === accumulatedFilter ? 'btn-selected' : 'btn-not-selected'"
                  class="w-50 mr-2"
                  @click="setTypeFilterAgents(accumulatedFilter)"
                >
                  <span>Filtrar acumulado</span>
                </button>

                <button
                  :class="filters.typeFilterAgents === sequencedFilter ? 'btn-selected' : 'btn-not-selected'"
                  class="w-50 ml-2"
                  @click="setTypeFilterAgents(sequencedFilter)"
                >
                  <span>Filtrar sequenciado</span>
                </button>
              </section>
            </section>

            <section v-if="filters.typeFilterAgents === accumulatedFilter" class='d-flex flex-wrap'>
              <section class='mr-5 mt-2'>
                <h6>ACGIH</h6>
                <b-form-group
                  class='objectiveAnalysisSelected'
                  v-slot='{ ariaDescribedby }'
                >
                  <b-form-checkbox-group
                    id='acgihAccumulatedFilter'
                    class='pr-2'
                    v-model='acgihAccumulateddFilter'
                    :aria-describedby='ariaDescribedby'
                    name='acgihAccumulateddFilter'
                    stacked
                  >
                    <b-form-checkbox
                      class='py-2 text'
                      value='consta'
                    >
                      <section class='d-flex align-items-center'>
                        <strong class='text-opcoes-relavao-legal'>
                          Consta
                        </strong>
                        <img class='ml-2' width='18' height='20' src='@/assets/images/consta.svg' alt='Consta' />
                      </section>
                    </b-form-checkbox>

                    <b-form-checkbox
                      class='py-2 text'
                      value='naoConsta'
                    >
                      <section class='d-flex align-items-center'>
                        <strong class='text-opcoes-relavao-legal'>
                          Não consta
                        </strong>
                        <img class='ml-2' width='16' height='15' src='@/assets/images/naoConsta.svg' alt='Consta' />
                      </section>
                    </b-form-checkbox>
                  </b-form-checkbox-group>
                </b-form-group>
              </section>

              <section class='mr-5 mt-2'>
                <h6>NR 15</h6>
                <b-form-group
                  class='objectiveAnalysisSelected'
                  v-slot='{ ariaDescribedby }'
                >
                  <b-form-checkbox-group
                    id='nr15AccumulatedFilter'
                    class='pr-2'
                    v-model='nr15AccumulatedFilter'
                    :aria-describedby='ariaDescribedby'
                    name='nr15AccumulatedFilter'
                    stacked
                  >
                    <b-form-checkbox
                      class='py-2 text'
                      value='consta'
                    >
                      <section class='d-flex align-items-center'>
                        <strong class='text-opcoes-relavao-legal'>
                          Consta
                        </strong>
                        <img class='ml-2' width='18' height='20' src='@/assets/images/consta.svg' alt='Consta' />
                      </section>
                    </b-form-checkbox>

                    <b-form-checkbox
                      class='py-2 text'
                      value='naoConsta'
                    >
                      <section class='d-flex align-items-center'>
                        <strong class='text-opcoes-relavao-legal'>
                          Não consta
                        </strong>
                        <img class='ml-2' width='16' height='15' src='@/assets/images/naoConsta.svg' alt='Consta' />
                      </section>
                    </b-form-checkbox>

                    <b-form-checkbox
                      class='py-2 text'
                      value='classificacao'
                    >
                      <section class='d-flex align-items-center'>
                        <strong class='text-opcoes-relavao-legal'>
                          Em classificação
                        </strong>
                        <img class='ml-2' width='16' height='15' src='@/assets/images/classificacao.svg' alt='Consta' />
                      </section>
                    </b-form-checkbox>
                  </b-form-checkbox-group>
                </b-form-group>
              </section>

              <section class='mr-5 mt-2'>
                <h6>LINACH</h6>
                <b-form-group
                  class='objectiveAnalysisSelected'
                  v-slot='{ ariaDescribedby }'
                >
                  <b-form-checkbox-group
                    id='linachAccumulatedFilter'
                    class='pr-2'
                    v-model='linachAccumulatedFilter'
                    :aria-describedby='ariaDescribedby'
                    name='linachAccumulatedFilter'
                    stacked
                  >
                    <b-form-checkbox
                      class='py-2 text'
                      value='consta'
                    >
                      <section class='d-flex align-items-center'>
                        <strong class='text-opcoes-relavao-legal'>
                          Consta
                        </strong>
                        <img class='ml-2' width='18' height='20' src='@/assets/images/consta.svg' alt='Consta' />
                      </section>
                    </b-form-checkbox>

                    <b-form-checkbox
                      class='py-2 text'
                      value='naoConsta'
                    >
                      <section class='d-flex align-items-center'>
                        <strong class='text-opcoes-relavao-legal'>
                          Não consta
                        </strong>
                        <img class='ml-2' width='16' height='15' src='@/assets/images/naoConsta.svg' alt='Consta' />
                      </section>
                    </b-form-checkbox>
                  </b-form-checkbox-group>
                </b-form-group>
              </section>

              <section class='mr-5 mt-2'>
                <h6>ESOCIAL - Tabela 24</h6>
                <b-form-group
                  class='objectiveAnalysisSelected'
                  v-slot='{ ariaDescribedby }'
                >
                  <b-form-checkbox-group
                    id='esocialAccumulatedFilter'
                    class='pr-2'
                    v-model='esocialAccumulatedFilter'
                    :aria-describedby='ariaDescribedby'
                    name='esocialAccumulatedFilter'
                    stacked
                  >
                    <b-form-checkbox
                      class='py-2 text'
                      value='consta'
                    >
                      <section class='d-flex align-items-center'>
                        <strong class='text-opcoes-relavao-legal'>
                          Consta
                        </strong>
                        <img class='ml-2' width='18' height='20' src='@/assets/images/consta.svg' alt='Consta' />
                      </section>
                    </b-form-checkbox>

                    <b-form-checkbox
                      class='py-2 text'
                      value='naoConsta'
                    >
                      <section class='d-flex align-items-center'>
                        <strong class='text-opcoes-relavao-legal'>
                          Não consta
                        </strong>
                        <img class='ml-2' width='16' height='15' src='@/assets/images/naoConsta.svg' alt='Consta' />
                      </section>
                    </b-form-checkbox>

                    <b-form-checkbox
                      class='py-2 text'
                      value='classificacao'
                    >
                      <section class='d-flex align-items-center'>
                        <strong class='text-opcoes-relavao-legal'>
                          Em classificação
                        </strong>
                        <img class='ml-2' width='16' height='15' src='@/assets/images/classificacao.svg' alt='Consta' />
                      </section>
                    </b-form-checkbox>
                  </b-form-checkbox-group>
                </b-form-group>
              </section>

              <section class='mr-5 mt-2'>
                <h6>DECRETO 3048/99 <br /> - Anexo IV</h6>
                <b-form-group
                  class='objectiveAnalysisSelected'
                  v-slot='{ ariaDescribedby }'
                >
                  <b-form-checkbox-group
                    id='decretoAccumulatedFilter'
                    class='pr-2'
                    v-model='decretoAccumulatedFilter'
                    :aria-describedby='ariaDescribedby'
                    name='decretoAccumulatedFilter'
                    stacked
                  >
                    <b-form-checkbox
                      class='py-2 text'
                      value='consta'
                    >
                      <section class='d-flex align-items-center'>
                        <strong class='text-opcoes-relavao-legal'>
                          Consta
                        </strong>
                        <img class='ml-2' width='18' height='20' src='@/assets/images/consta.svg' alt='Consta' />
                      </section>
                    </b-form-checkbox>

                    <b-form-checkbox
                      class='py-2 text'
                      value='naoConsta'
                    >
                      <section class='d-flex align-items-center'>
                        <strong class='text-opcoes-relavao-legal'>
                          Não consta
                        </strong>
                        <img class='ml-2' width='16' height='15' src='@/assets/images/naoConsta.svg' alt='Consta' />
                      </section>
                    </b-form-checkbox>

                    <b-form-checkbox
                      class='py-2 text'
                      value='classificacao'
                    >
                      <section class='d-flex align-items-center'>
                        <strong class='text-opcoes-relavao-legal'>
                          Em classificação
                        </strong>
                        <img class='ml-2' width='16' height='15' src='@/assets/images/classificacao.svg' alt='Consta' />
                      </section>
                    </b-form-checkbox>
                  </b-form-checkbox-group>
                </b-form-group>
              </section>
            </section>

            <section v-if="filters.typeFilterAgents === sequencedFilter" class='d-flex flex-wrap'>
              <section class='mr-5 mt-2'>
                <h6>ACGIH</h6>
                <b-form-group
                  class='objectiveAnalysisSelected'
                  v-slot='{ ariaDescribedby }'
                >
                  <b-form-checkbox-group
                    id='acgih'
                    class='pr-2'
                    v-model='acgih'
                    :aria-describedby='ariaDescribedby'
                    name='acgih'
                    stacked
                  >
                    <b-form-checkbox
                      class='py-2 text'
                      value='consta'
                      @change="updateSelectedFilter('acgih', 'consta')"
                    >
                      <section class='d-flex align-items-center'>
                        <strong class='text-opcoes-relavao-legal'>
                          Consta
                        </strong>
                        <img class='ml-2' width='18' height='20' src='@/assets/images/consta.svg' alt='Consta' />
                      </section>
                    </b-form-checkbox>

                    <b-form-checkbox
                      class='py-2 text'
                      value='naoConsta'
                      @change="updateSelectedFilter('acgih', 'naoConsta')"
                    >
                      <section class='d-flex align-items-center'>
                        <strong class='text-opcoes-relavao-legal'>
                          Não consta
                        </strong>
                        <img class='ml-2' width='16' height='15' src='@/assets/images/naoConsta.svg' alt='Consta' />
                      </section>
                    </b-form-checkbox>
                  </b-form-checkbox-group>
                </b-form-group>
              </section>

              <section class='mr-5 mt-2'>
                <h6>NR 15</h6>
                <b-form-group
                  class='objectiveAnalysisSelected'
                  v-slot='{ ariaDescribedby }'
                >
                  <b-form-checkbox-group
                    id='nr15'
                    class='pr-2'
                    v-model='nr15'
                    :aria-describedby='ariaDescribedby'
                    name='nr15'
                    stacked
                  >
                    <b-form-checkbox
                      class='py-2 text'
                      value='consta'
                      @change="updateSelectedFilter('nr15', 'consta')"
                    >
                      <section class='d-flex align-items-center'>
                        <strong class='text-opcoes-relavao-legal'>
                          Consta
                        </strong>
                        <img class='ml-2' width='18' height='20' src='@/assets/images/consta.svg' alt='Consta' />
                      </section>
                    </b-form-checkbox>

                    <b-form-checkbox
                      class='py-2 text'
                      value='naoConsta'
                      @change="updateSelectedFilter('nr15', 'naoConsta')"
                    >
                      <section class='d-flex align-items-center'>
                        <strong class='text-opcoes-relavao-legal'>
                          Não consta
                        </strong>
                        <img class='ml-2' width='16' height='15' src='@/assets/images/naoConsta.svg' alt='Consta' />
                      </section>
                    </b-form-checkbox>

                    <b-form-checkbox
                      class='py-2 text'
                      value='classificacao'
                      @change="updateSelectedFilter('nr15', 'classificacao')"
                    >
                      <section class='d-flex align-items-center'>
                        <strong class='text-opcoes-relavao-legal'>
                          Em classificação
                        </strong>
                        <img class='ml-2' width='16' height='15' src='@/assets/images/classificacao.svg' alt='Consta' />
                      </section>
                    </b-form-checkbox>
                  </b-form-checkbox-group>
                </b-form-group>
              </section>

              <section class='mr-5 mt-2'>
                <h6>LINACH</h6>
                <b-form-group
                  class='objectiveAnalysisSelected'
                  v-slot='{ ariaDescribedby }'
                >
                  <b-form-checkbox-group
                    id='linach'
                    class='pr-2'
                    v-model='linach'
                    :aria-describedby='ariaDescribedby'
                    name='linach'
                    stacked
                  >
                    <b-form-checkbox
                      class='py-2 text'
                      value='consta'
                      @change="updateSelectedFilter('linach', 'consta')"
                    >
                      <section class='d-flex align-items-center'>
                        <strong class='text-opcoes-relavao-legal'>
                          Consta
                        </strong>
                        <img class='ml-2' width='18' height='20' src='@/assets/images/consta.svg' alt='Consta' />
                      </section>
                    </b-form-checkbox>

                    <b-form-checkbox
                      class='py-2 text'
                      value='naoConsta'
                      @change="updateSelectedFilter('linach', 'naoConsta')"
                    >
                      <section class='d-flex align-items-center'>
                        <strong class='text-opcoes-relavao-legal'>
                          Não consta
                        </strong>
                        <img class='ml-2' width='16' height='15' src='@/assets/images/naoConsta.svg' alt='Consta' />
                      </section>
                    </b-form-checkbox>
                  </b-form-checkbox-group>
                </b-form-group>
              </section>

              <section class='mr-5 mt-2'>
                <h6>ESOCIAL - Tabela 24</h6>
                <b-form-group
                  class='objectiveAnalysisSelected'
                  v-slot='{ ariaDescribedby }'
                >
                  <b-form-checkbox-group
                    id='esocial'
                    class='pr-2'
                    v-model='esocial'
                    :aria-describedby='ariaDescribedby'
                    name='esocial'
                    stacked
                  >
                    <b-form-checkbox
                      class='py-2 text'
                      value='consta'
                      @change="updateSelectedFilter('esocial', 'consta')"
                    >
                      <section class='d-flex align-items-center'>
                        <strong class='text-opcoes-relavao-legal'>
                          Consta
                        </strong>
                        <img class='ml-2' width='18' height='20' src='@/assets/images/consta.svg' alt='Consta' />
                      </section>
                    </b-form-checkbox>

                    <b-form-checkbox
                      class='py-2 text'
                      value='naoConsta'
                      @change="updateSelectedFilter('esocial', 'naoConsta')"
                    >
                      <section class='d-flex align-items-center'>
                        <strong class='text-opcoes-relavao-legal'>
                          Não consta
                        </strong>
                        <img class='ml-2' width='16' height='15' src='@/assets/images/naoConsta.svg' alt='Consta' />
                      </section>
                    </b-form-checkbox>

                    <b-form-checkbox
                      class='py-2 text'
                      value='classificacao'
                      @change="updateSelectedFilter('esocial', 'classificacao')"
                    >
                      <section class='d-flex align-items-center'>
                        <strong class='text-opcoes-relavao-legal'>
                          Em classificação
                        </strong>
                        <img class='ml-2' width='16' height='15' src='@/assets/images/classificacao.svg' alt='Consta' />
                      </section>
                    </b-form-checkbox>
                  </b-form-checkbox-group>
                </b-form-group>
              </section>

              <section class='mr-5 mt-2'>
                <h6>DECRETO 3048/99 <br /> - Anexo IV</h6>
                <b-form-group
                  class='objectiveAnalysisSelected'
                  v-slot='{ ariaDescribedby }'
                >
                  <b-form-checkbox-group
                    id='checkbox-group-3'
                    class='pr-2'
                    v-model='decreto'
                    :aria-describedby='ariaDescribedby'
                    name='decreto'
                    stacked
                  >
                    <b-form-checkbox
                      class='py-2 text'
                      value='consta'
                      @change="updateSelectedFilter('decreto', 'consta')"
                    >
                      <section class='d-flex align-items-center'>
                        <strong class='text-opcoes-relavao-legal'>
                          Consta
                        </strong>
                        <img class='ml-2' width='18' height='20' src='@/assets/images/consta.svg' alt='Consta' />
                      </section>
                    </b-form-checkbox>

                    <b-form-checkbox
                      class='py-2 text'
                      value='naoConsta'
                      @change="updateSelectedFilter('decreto', 'naoConsta')"
                    >
                      <section class='d-flex align-items-center'>
                        <strong class='text-opcoes-relavao-legal'>
                          Não consta
                        </strong>
                        <img class='ml-2' width='16' height='15' src='@/assets/images/naoConsta.svg' alt='Consta' />
                      </section>
                    </b-form-checkbox>

                    <b-form-checkbox
                      class='py-2 text'
                      value='classificacao'
                      @change="updateSelectedFilter('decreto', 'classificacao')"
                    >
                      <section class='d-flex align-items-center'>
                        <strong class='text-opcoes-relavao-legal'>
                          Em classificação
                        </strong>
                        <img class='ml-2' width='16' height='15' src='@/assets/images/classificacao.svg' alt='Consta' />
                      </section>
                    </b-form-checkbox>
                  </b-form-checkbox-group>
                </b-form-group>
              </section>
            </section>
          </section>
        </section>

        <section class='mt-4'>
          <hr/>
        </section>

        <section class="filter-forwarded-agents p-3">
          <section class="d-flex justify-content-between align-items-center">
            <section >
              <p class='title mb-1 pb-0'>Filtrar agentes repetidos</p>
              <p class="observations" v-if="!filterForwardedAgentsSelected || filterForwardedAgentsSelected.length < 1">* A adição do filtro de agentes repetidos fará com que em tela não sejam exibidos os agentes mais de uma vez</p>
              <p class="observations" v-if="!filterForwardedAgentsSelected || filterForwardedAgentsSelected.length < 1">* A situação se aplica aos casos de agentes sem vínculo de produto e produtos que venham a ter sido cadastrados com o mesmo agente mais de uma vez.</p>
              <span v-if="!filterForwardedAgentsSelected || filterForwardedAgentsSelected.length < 1" class="sub-title">2 opções</span>

              <span>Itens selecionados: </span>
              <span v-if="filterForwardedAgentsSelected && filterForwardedAgentsSelected.length > 0 && filterForwardedAgentsSelected.includes('SHOW_ONLY_ONCE')">Mostrar só uma vez cada agente </span>
              <span v-if="filterForwardedAgentsSelected && filterForwardedAgentsSelected.length > 0 && filterForwardedAgentsSelected.includes('SHOW_ALL')">Mostrar todos (com repetição) </span>
            </section>

            <section class="d-flex justify-content-between align-items-center ml-2">
              <b-icon
                @click="filterForwardedAgents = !filterForwardedAgents"
                font-scale='2'
                icon='chevron-down'
                color='#262626'
                class='cursor-pointer transition'
                v-if="filterForwardedAgents"
              >
              </b-icon>
              <b-icon
                v-else
                @click="filterForwardedAgents = !filterForwardedAgents"
                font-scale='2'
                icon='chevron-right'
                color='#262626'
                class='cursor-pointer transition'
              >
              </b-icon>
            </section>
          </section>

          <section v-if="filterForwardedAgents" class="mt-2">
              <b-form-group
                v-slot='{ ariaDescribedby }'
              >
                <b-form-checkbox-group
                  id='esocial'
                  class='pr-2'
                  v-model='filterForwardedAgentsSelected'
                  :aria-describedby='ariaDescribedby'
                  name='filterForwardedAgents'
                  stacked
                >
                  <section class="checkbox-item mb-3">
                    <b-form-checkbox
                      value='SHOW_ONLY_ONCE'
                      @change="updateFilterForwardedAgentsSelected('filterForwardedAgentsSelected', 'SHOW_ONLY_ONCE')"
                    >
                    <span>
                      Mostrar só uma vez cada agente
                    </span>
                    </b-form-checkbox>
                  </section>

                  <section class="checkbox-item mb-2">
                    <b-form-checkbox
                      value='SHOW_ALL'
                      @change="updateFilterForwardedAgentsSelected('filterForwardedAgentsSelected', 'SHOW_ALL')"
                    >
                      <span>
                        Mostrar todos (com repetição)
                      </span>
                    </b-form-checkbox>
                  </section>
                </b-form-checkbox-group>
              </b-form-group>
          </section>
        </section>

        <section class="filter-forwarded-agents p-3 mt-3">
          <section class="d-flex justify-content-between align-items-center">
            <section class="pr-3">
              <p class='title mb-1 pb-0'>Filtrar por agente</p>
              <p class="observations mb-0" v-if="!selectedAgentsFilter || selectedAgentsFilter.length <= 0">* Selecione um ou mais agentes para exibir apenas os agentes correspondentes, mantendo os produtos em que aparecem.</p>
            </section>

            <section class="d-flex justify-content-end align-items-center ml-2 flex-shrink-0">
              <b-icon
                @click="filterByAgent = !filterByAgent"
                font-scale='2'
                icon='chevron-down'
                color='#262626'
                class='cursor-pointer transition'
                v-if="filterByAgent"
              >
              </b-icon>
              <b-icon
                v-else
                @click="filterByAgent = !filterByAgent"
                font-scale='2'
                icon='chevron-right'
                color='#262626'
                class='cursor-pointer transition'
              >
              </b-icon>
            </section>
          </section>

          <section v-if="selectedAgentsFilter.length > 0" class="mt-3">
            <span class="observations d-block mb-2">
              Itens selecionados ({{ selectedAgents.length }}):
            </span>
            <ul class="selected-agents-list">
              <li v-for="agent in selectedAgents" :key="agent._id">
                {{ agent.name }}
              </li>
            </ul>
          </section>

          <section v-if="filterByAgent" class="mt-4 pt-2">
            <b-input-group v-if="agentsName.length > 0" class="mb-3">
              <b-input-group-prepend is-text>
                <b-icon icon="search" color="#707070"></b-icon>
              </b-input-group-prepend>
              <b-form-input
                v-model="agentSearchTerm"
                type="text"
                placeholder="Buscar agente na lista (nome ou CAS)"
              />
            </b-input-group>
            <section
              v-if="filteredAgentsName.length > 0"
              class="agents-list"
              style='display: grid; grid-template-columns: repeat(auto-fill, minmax(32%, 1fr)); gap: 10px'
            >
              <b-form-checkbox-group
                v-for='agent in filteredAgentsName'
                v-model='selectedAgentsFilter'
                :key='agent._id'
                stacked
              >
                <section class='product'>
                  <b-form-checkbox
                    button-variant="info"
                    :value='agent._id'
                  >
                    <span
                      class='text'
                      :style="selectedAgentsFilter.includes(agent._id) ? 'color: #022245;font-weight: 700;': 'color: #262626; font-weight: 400;'"
                    >
                      {{ agent.name }}
                    </span>
                  </b-form-checkbox>
                </section>
              </b-form-checkbox-group>
            </section>
            <span v-else-if="agentsName.length > 0" class="observations">Nenhum agente corresponde à busca.</span>
            <span v-else class="observations">Nenhum agente adicionado para filtrar.</span>
          </section>
        </section>

        <section class='d-flex justify-content-end mt-3 w-100'>
          <base-button
            class='btn-clear-filter w-25 mr-3'
            @click='clearSelectedFilters()'
          >
            <span>Limpar filtros</span>
          </base-button>

          <base-button
            class='btn_filter w-75'
            @click='showModalConfirmation()'
          >
            <span>Pesquisar agentes</span>
          </base-button>
        </section>
      </section>
    </b-modal>

    <b-popover
      target="applied-filters"
      triggers="hover"
      placement="top"
      v-if="appliedFilters && tabView !== 'Gro' && heightFilter >= 30"
    >
      <section class="d-flex align-items-center flex-wrap">
        <section class='d-flex align-items-center mb-1'>
          <img class='' width='18' height='20' src='@/assets/images/filter.svg' alt='Filtro' />

          <span class='text-filter'>Filtros Aplicados:&nbsp;</span>
        </section>

        <!--Filtrar por agente-->
        <section class="mr-2" v-if="appliedAgentsNames">
          <span class='text-filter-applied'>Agente: {{ appliedAgentsNames }}</span>
        </section>

        <!--ACGIH-->
        <section class="mr-2" v-if="summaryMeta.acgih && summaryMeta.acgih.length > 0 && summaryMeta.acgih.includes('consta')">
          <span class='text-filter-applied'>ACGIH Consta</span>
          <img
            class='ml-1 mb-1'
            width='13'
            height='12'
            v-bind:src='require(`../../../assets/images/consta.svg`)' alt=''
          />
        </section>

        <section class="mr-2" v-if="summaryMeta.acgih && summaryMeta.acgih.length > 0 && summaryMeta.acgih.includes('naoConsta')">
          <span class='text-filter-applied'>ACGIH Não consta</span>
          <img
            class='ml-1 mb-1'
            width='13'
            height='12'
            v-bind:src='require(`../../../assets/images/naoConsta.svg`)' alt=''
          />
        </section>

        <!--NR 15-->
        <section class="mr-2" v-if="summaryMeta.nr15 && summaryMeta.nr15.length > 0 && summaryMeta.nr15.includes('consta')">
          <span class='text-filter-applied'>NR 15 Consta</span>
          <img
            class='ml-1 mb-1'
            width='13'
            height='12'
            v-bind:src='require(`../../../assets/images/consta.svg`)' alt=''
          />
        </section>

        <section class="mr-2" v-if="summaryMeta.nr15 && summaryMeta.nr15.length > 0 && summaryMeta.nr15.includes('naoConsta')">
          <span class='text-filter-applied'>NR 15 Não consta</span>
          <img
            class='ml-1 mb-1'
            width='13'
            height='12'
            v-bind:src='require(`../../../assets/images/naoConsta.svg`)' alt=''
          />
        </section>

        <section class="mr-2" v-if="summaryMeta.nr15 && summaryMeta.nr15.length > 0 && summaryMeta.nr15.includes('classificacao')">
          <span class='text-filter-applied'>NR 15 Em classificação</span>
          <img
            class='ml-1 mb-1'
            width='13'
            height='12'
            v-bind:src='require(`../../../assets/images/classificacao.svg`)' alt=''
          />
        </section>


        <!--LINACH-->
        <section class="mr-2" v-if="summaryMeta.linach && summaryMeta.linach.length > 0 && summaryMeta.linach.includes('consta')">
          <span class='text-filter-applied'>LINACH Consta</span>
          <img
            class='ml-1 mb-1'
            width='13'
            height='12'
            v-bind:src='require(`../../../assets/images/consta.svg`)' alt=''
          />
        </section>

        <section class="mr-2" v-if="summaryMeta.linach && summaryMeta.linach.length > 0 && summaryMeta.linach.includes('naoConsta')">
          <span class='text-filter-applied'>LINACH Não consta</span>
          <img
            class='ml-1 mb-1'
            width='13'
            height='12'
            v-bind:src='require(`../../../assets/images/naoConsta.svg`)' alt=''
          />
        </section>


        <!--ESOCIAL - Tabela 24-->
        <section class="mr-2" v-if="summaryMeta.esocial && summaryMeta.esocial.length > 0 && summaryMeta.esocial.includes('consta')">
          <span class='text-filter-applied'>ESOCIAL - Tabela 24 Consta</span>
          <img
            class='ml-1 mb-1'
            width='13'
            height='12'
            v-bind:src='require(`../../../assets/images/consta.svg`)' alt=''
          />
        </section>

        <section class="mr-2" v-if="summaryMeta.esocial && summaryMeta.esocial.length > 0 && summaryMeta.esocial.includes('naoConsta')">
          <span class='text-filter-applied'>ESOCIAL - Tabela 24 Não consta</span>
          <img
            class='ml-1 mb-1'
            width='13'
            height='12'
            v-bind:src='require(`../../../assets/images/naoConsta.svg`)' alt=''
          />
        </section>

        <section class="mr-2" v-if="summaryMeta.esocial && summaryMeta.esocial.length > 0 && summaryMeta.esocial.includes('classificacao')">
          <span class='text-filter-applied'>ESOCIAL - Tabela 24 Em classificação</span>
          <img
            class='ml-1 mb-1'
            width='13'
            height='12'
            v-bind:src='require(`../../../assets/images/classificacao.svg`)' alt=''
          />
        </section>


        <!--DECRETO 3048/99 - Anexo IV-->
        <section class="mr-2" v-if="summaryMeta.decreto && summaryMeta.decreto.length > 0 && summaryMeta.decreto.includes('consta')">
          <span class='text-filter-applied'>DECRETO 3048/99 - Anexo IV Consta</span>
          <img
            class='ml-1 mb-1'
            width='13'
            height='12'
            v-bind:src='require(`../../../assets/images/consta.svg`)' alt=''
          />
        </section>

        <section class="mr-2" v-if="summaryMeta.decreto && summaryMeta.decreto.length > 0 && summaryMeta.decreto.includes('naoConsta')">
          <span class='text-filter-applied'>DECRETO 3048/99 - Anexo IV Não consta</span>
          <img
            class='ml-1 mb-1'
            width='13'
            height='12'
            v-bind:src='require(`../../../assets/images/naoConsta.svg`)' alt=''
          />
        </section>

        <section class="mr-2" v-if="summaryMeta.decreto && summaryMeta.decreto.length > 0 && summaryMeta.decreto.includes('classificacao')">
          <span class='text-filter-applied'>DECRETO 3048/99 - Anexo IV Em classificação</span>
          <img
            class='ml-1 mb-1'
            width='13'
            height='12'
            v-bind:src='require(`../../../assets/images/classificacao.svg`)' alt=''
          />
        </section>

        <section v-if='summaryMeta.products && summaryMeta.products.length > 0'>
                <span class='text-filter-applied'>
                  <strong> Produtos:&nbsp;</strong> {{ products.filter((x) => summaryMeta.products.includes(x._id)).map((y) => y.name).join(', ') }}
                </span>
        </section>

        <section v-if="summaryMeta.filterForwardedAgents && summaryMeta.filterForwardedAgents === 'SHOW_ONLY_ONCE'">
                <span class='text-filter-applied'>
                  <strong>Mostrar só uma vez cada agente </strong>
                </span>
        </section>
      </section>
    </b-popover>

    <section id="applied-filters" class='w-100 d-flex justify-content-between'>
      <section
        v-if="appliedFilters && tabView !== 'Gro'"
        class='filter-content mt-2 d-flex align-items-center flex-wrap justify-content-between  position-relative'
      >
        <button
          v-if="instructionalVideosByTab && instructionalVideosByTab.length > 0"
          class="btn-video d-flex align-items-center mr-2"
          @click="showModalTabVideos()"
        >
          <svg width="16" height="16" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="0.117188" y="0.117432" width="12" height="12" rx="6" fill="#022245"/>
            <path d="M6.11741 11.7348C6.85524 11.7358 7.58599 11.5909 8.26765 11.3086C8.94931 11.0262 9.56845 10.6119 10.0895 10.0895C10.6119 9.56845 11.0262 8.94931 11.3086 8.26765C11.5909 7.58599 11.7358 6.85524 11.7348 6.11741C11.7358 5.37959 11.5909 4.64885 11.3085 3.96719C11.0262 3.28553 10.6119 2.66639 10.0895 2.14534C9.56845 1.62293 8.94931 1.20864 8.26765 0.926278C7.58599 0.643915 6.85524 0.499049 6.11741 0.500005C5.37959 0.499064 4.64885 0.643937 3.96719 0.926299C3.28553 1.20866 2.66639 1.62295 2.14534 2.14534C1.62295 2.66639 1.20866 3.28553 0.926299 3.96719C0.643937 4.64885 0.499064 5.37959 0.500005 6.11741C0.499049 6.85524 0.643915 7.58599 0.926278 8.26765C1.20864 8.94931 1.62293 9.56845 2.14534 10.0895C2.66639 10.6119 3.28553 11.0262 3.96719 11.3085C4.64885 11.5909 5.37959 11.7358 6.11741 11.7348Z" stroke="#022245" stroke-linejoin="round"/>
            <path d="M6.11816 3.65125C6.06456 3.65125 6.0135 3.62957 5.97559 3.59167C5.93768 3.55377 5.91602 3.50271 5.91602 3.4491C5.91602 3.39548 5.93767 3.34443 5.97559 3.30652C6.0135 3.2686 6.06454 3.24695 6.11816 3.24695C6.17178 3.24696 6.22283 3.26861 6.26074 3.30652C6.29864 3.34443 6.32031 3.39549 6.32031 3.4491C6.32031 3.50271 6.29865 3.55377 6.26074 3.59167C6.22283 3.62958 6.17178 3.65124 6.11816 3.65125Z" fill="#ECF0F3" stroke="#ECF0F3"/>
            <path d="M6.11719 9.76874L6.11719 5.27481L6.11719 9.76874Z" fill="#ECF0F3"/>
            <path d="M6.11719 9.76874L6.11719 5.27481" stroke="#ECF0F3" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>

          <span class="ml-1">Iniciar tutorial de uso</span>
        </button>

        <section
          id="filters"
          v-if="appliedFilters && tabView !== 'Gro'"
          class="d-flex align-items-center flex-wrap  justify-content-start pl-1"
          style="text-align: left; margin-right: 50px"
        >
          <section  v-if="tabView !== 'Gro'" class='d-flex flex-nowrap'>
            <a
              class='btn-filtros mr-2 d-flex align-items-center'
              @click='clearSelectedFilters()'
            >
              <img
                class='mr-1'
                width='14'
                height='14'
                src='@/assets/images/limparFiltros.svg'
                alt='Limpar filtros'
              />
              <span
                class='text-btn-filtros'
              >
              Limpar filtros
            </span>
            </a>

            <a
              class='btn-filtros mr-2  d-flex align-items-center'
              @click='showModalFilter()'
            >
              <img
                class='ml-1 mr-1'
                width='21'
                height='21'
                src='@/assets/images/editarFiltros.svg'
                alt='Editar filtros'
              />
              <span
                class='text-btn-filtros'
              >
              Editar
            </span>
            </a>
          </section>

          <section class='d-flex align-items-center mr-2'>
            <img  width='18' height='20' src='@/assets/images/filter.svg' alt='Filtro' />

            <span class='text-filte'>Filtros Aplicados: </span>
          </section>

          <!--Filtrar por agente-->
          <section class="mr-2" v-if="appliedAgentsNames">
            <span class='text-filter-applied'>Agente: {{ appliedAgentsNames }}</span>
          </section>

          <!--ACGIH-->
          <section class="mr-2" v-if="summaryMeta.acgih && summaryMeta.acgih.length > 0 && summaryMeta.acgih.includes('consta')">
            <span class='text-filter-applied'>ACGIH Consta</span>
            <img
              class='ml-1 mb-1'
              width='13'
              height='12'
              v-bind:src='require(`../../../assets/images/consta.svg`)' alt=''
            />
          </section>

          <section class="mr-2" v-if="summaryMeta.acgih && summaryMeta.acgih.length > 0 && summaryMeta.acgih.includes('naoConsta')">
            <span class='text-filter-applied'>ACGIH Não consta</span>
            <img
              class='ml-1 mb-1'
              width='13'
              height='12'
              v-bind:src='require(`../../../assets/images/naoConsta.svg`)' alt=''
            />
          </section>

          <!--NR 15-->
          <section class="mr-2" v-if="summaryMeta.nr15 && summaryMeta.nr15.length > 0 && summaryMeta.nr15.includes('consta')">
            <span class='text-filter-applied'>NR 15 Consta</span>
            <img
              class='ml-1 mb-1'
              width='13'
              height='12'
              v-bind:src='require(`../../../assets/images/consta.svg`)' alt=''
            />
          </section>

          <section class="mr-2" v-if="summaryMeta.nr15 && summaryMeta.nr15.length > 0 && summaryMeta.nr15.includes('naoConsta')">
            <span class='text-filter-applied'>NR 15 Não consta</span>
            <img
              class='ml-1 mb-1'
              width='13'
              height='12'
              v-bind:src='require(`../../../assets/images/naoConsta.svg`)' alt=''
            />
          </section>

          <section class="mr-2" v-if="summaryMeta.nr15 && summaryMeta.nr15.length > 0 && summaryMeta.nr15.includes('classificacao')">
            <span class='text-filter-applied'>NR 15 Em classificação</span>
            <img
              class='ml-1 mb-1'
              width='13'
              height='12'
              v-bind:src='require(`../../../assets/images/classificacao.svg`)' alt=''
            />
          </section>


          <!--LINACH-->
          <section class="mr-2" v-if="summaryMeta.linach && summaryMeta.linach.length > 0 && summaryMeta.linach.includes('consta')">
            <span class='text-filter-applied'>LINACH Consta</span>
            <img
              class='ml-1 mb-1'
              width='13'
              height='12'
              v-bind:src='require(`../../../assets/images/consta.svg`)' alt=''
            />
          </section>

          <section class="mr-2" v-if="summaryMeta.linach && summaryMeta.linach.length > 0 && summaryMeta.linach.includes('naoConsta')">
            <span class='text-filter-applied'>LINACH Não consta</span>
            <img
              class='ml-1 mb-1'
              width='13'
              height='12'
              v-bind:src='require(`../../../assets/images/naoConsta.svg`)' alt=''
            />
          </section>


          <!--ESOCIAL - Tabela 24-->
          <section class="mr-2" v-if="summaryMeta.esocial && summaryMeta.esocial.length > 0 && summaryMeta.esocial.includes('consta')">
            <span class='text-filter-applied'>ESOCIAL - Tabela 24 Consta</span>
            <img
              class='ml-1 mb-1'
              width='13'
              height='12'
              v-bind:src='require(`../../../assets/images/consta.svg`)' alt=''
            />
          </section>

          <section class="mr-2" v-if="summaryMeta.esocial && summaryMeta.esocial.length > 0 && summaryMeta.esocial.includes('naoConsta')">
            <span class='text-filter-applied'>ESOCIAL - Tabela 24 Não consta</span>
            <img
              class='ml-1 mb-1'
              width='13'
              height='12'
              v-bind:src='require(`../../../assets/images/naoConsta.svg`)' alt=''
            />
          </section>

          <section class="mr-2" v-if="summaryMeta.esocial && summaryMeta.esocial.length > 0 && summaryMeta.esocial.includes('classificacao')">
            <span class='text-filter-applied'>ESOCIAL - Tabela 24 Em classificação</span>
            <img
              class='ml-1 mb-1'
              width='13'
              height='12'
              v-bind:src='require(`../../../assets/images/classificacao.svg`)' alt=''
            />
          </section>


          <!--DECRETO 3048/99 - Anexo IV-->
          <section class="mr-2" v-if="summaryMeta.decreto && summaryMeta.decreto.length > 0 && summaryMeta.decreto.includes('consta')">
            <span class='text-filter-applied'>DECRETO 3048/99 - Anexo IV Consta</span>
            <img
              class='ml-1 mb-1'
              width='13'
              height='12'
              v-bind:src='require(`../../../assets/images/consta.svg`)' alt=''
            />
          </section>

          <section class="mr-2" v-if="summaryMeta.decreto && summaryMeta.decreto.length > 0 && summaryMeta.decreto.includes('naoConsta')">
            <span class='text-filter-applied'>DECRETO 3048/99 - Anexo IV Não consta</span>
            <img
              class='ml-1 mb-1'
              width='13'
              height='12'
              v-bind:src='require(`../../../assets/images/naoConsta.svg`)' alt=''
            />
          </section>

          <section class="mr-2" v-if="summaryMeta.decreto && summaryMeta.decreto.length > 0 && summaryMeta.decreto.includes('classificacao')">
            <span class='text-filter-applied'>DECRETO 3048/99 - Anexo IV Em classificação</span>
            <img
              class='ml-1 mb-1'
              width='13'
              height='12'
              v-bind:src='require(`../../../assets/images/classificacao.svg`)' alt=''
            />
          </section>

          <section class="mr-2 word-break" v-if='summaryMeta.products && summaryMeta.products.length > 0' style="text-align: left">
            <span class='text-filter-applied '>
              <strong> Produtos:&nbsp;</strong> {{ products.filter((x) => summaryMeta.products.includes(x._id)).map((y) => y.name).join(', ') }}
            </span>
          </section>

          <section v-if="summaryMeta.filterForwardedAgents && summaryMeta.filterForwardedAgents === 'SHOW_ONLY_ONCE'">
                <span class='text-filter-applied'>
                  <strong>Mostrar só uma vez cada agente </strong>
                </span>
          </section>

          <section v-if="heightFilter >= 30" style="right: 5px; bottom: 0" class="position-absolute">
            <section class="d-flex align-content-center">
              <h2 class="mb-0">...</h2>
              <b-icon
                class='ml-1 mt-3'
                font-scale="1.2"
                icon="info-circle-fill"
                variant="info"
              >
              </b-icon>
            </section>
          </section>
        </section>
      </section>

      <section v-else class='mt-2 float-left'>
        <section v-if="tabView !== 'Gro'"  class="d-flex">
          <button
            v-if="instructionalVideosByTab && instructionalVideosByTab.length > 0"
            class="btn-video d-flex align-items-center mr-2"
            @click="showModalTabVideos()"
          >
            <svg width="16" height="16" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="0.117188" y="0.117432" width="12" height="12" rx="6" fill="#022245"/>
              <path d="M6.11741 11.7348C6.85524 11.7358 7.58599 11.5909 8.26765 11.3086C8.94931 11.0262 9.56845 10.6119 10.0895 10.0895C10.6119 9.56845 11.0262 8.94931 11.3086 8.26765C11.5909 7.58599 11.7358 6.85524 11.7348 6.11741C11.7358 5.37959 11.5909 4.64885 11.3085 3.96719C11.0262 3.28553 10.6119 2.66639 10.0895 2.14534C9.56845 1.62293 8.94931 1.20864 8.26765 0.926278C7.58599 0.643915 6.85524 0.499049 6.11741 0.500005C5.37959 0.499064 4.64885 0.643937 3.96719 0.926299C3.28553 1.20866 2.66639 1.62295 2.14534 2.14534C1.62295 2.66639 1.20866 3.28553 0.926299 3.96719C0.643937 4.64885 0.499064 5.37959 0.500005 6.11741C0.499049 6.85524 0.643915 7.58599 0.926278 8.26765C1.20864 8.94931 1.62293 9.56845 2.14534 10.0895C2.66639 10.6119 3.28553 11.0262 3.96719 11.3085C4.64885 11.5909 5.37959 11.7358 6.11741 11.7348Z" stroke="#022245" stroke-linejoin="round"/>
              <path d="M6.11816 3.65125C6.06456 3.65125 6.0135 3.62957 5.97559 3.59167C5.93768 3.55377 5.91602 3.50271 5.91602 3.4491C5.91602 3.39548 5.93767 3.34443 5.97559 3.30652C6.0135 3.2686 6.06454 3.24695 6.11816 3.24695C6.17178 3.24696 6.22283 3.26861 6.26074 3.30652C6.29864 3.34443 6.32031 3.39549 6.32031 3.4491C6.32031 3.50271 6.29865 3.55377 6.26074 3.59167C6.22283 3.62958 6.17178 3.65124 6.11816 3.65125Z" fill="#ECF0F3" stroke="#ECF0F3"/>
              <path d="M6.11719 9.76874L6.11719 5.27481L6.11719 9.76874Z" fill="#ECF0F3"/>
              <path d="M6.11719 9.76874L6.11719 5.27481" stroke="#ECF0F3" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>

            <span class="ml-1">Iniciar tutorial de uso</span>
          </button>

          <button class='btn-new-filter' @click='showModalFilter()'>
            <img class='ml-1 mr-2' width='18' height='20' src='@/assets/images/filter.svg' alt='Filtro' />

            <span class='text-filter pr-2'>Aplicar novo filtro</span>
          </button>
        </section>

        <button
          v-else-if="instructionalVideosByTab && instructionalVideosByTab.length > 0"
          class="btn-video d-flex align-items-center"
          @click="showModalTabVideos()"
        >
          <svg width="16" height="16" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="0.117188" y="0.117432" width="12" height="12" rx="6" fill="#022245"/>
            <path d="M6.11741 11.7348C6.85524 11.7358 7.58599 11.5909 8.26765 11.3086C8.94931 11.0262 9.56845 10.6119 10.0895 10.0895C10.6119 9.56845 11.0262 8.94931 11.3086 8.26765C11.5909 7.58599 11.7358 6.85524 11.7348 6.11741C11.7358 5.37959 11.5909 4.64885 11.3085 3.96719C11.0262 3.28553 10.6119 2.66639 10.0895 2.14534C9.56845 1.62293 8.94931 1.20864 8.26765 0.926278C7.58599 0.643915 6.85524 0.499049 6.11741 0.500005C5.37959 0.499064 4.64885 0.643937 3.96719 0.926299C3.28553 1.20866 2.66639 1.62295 2.14534 2.14534C1.62295 2.66639 1.20866 3.28553 0.926299 3.96719C0.643937 4.64885 0.499064 5.37959 0.500005 6.11741C0.499049 6.85524 0.643915 7.58599 0.926278 8.26765C1.20864 8.94931 1.62293 9.56845 2.14534 10.0895C2.66639 10.6119 3.28553 11.0262 3.96719 11.3085C4.64885 11.5909 5.37959 11.7358 6.11741 11.7348Z" stroke="#022245" stroke-linejoin="round"/>
            <path d="M6.11816 3.65125C6.06456 3.65125 6.0135 3.62957 5.97559 3.59167C5.93768 3.55377 5.91602 3.50271 5.91602 3.4491C5.91602 3.39548 5.93767 3.34443 5.97559 3.30652C6.0135 3.2686 6.06454 3.24695 6.11816 3.24695C6.17178 3.24696 6.22283 3.26861 6.26074 3.30652C6.29864 3.34443 6.32031 3.39549 6.32031 3.4491C6.32031 3.50271 6.29865 3.55377 6.26074 3.59167C6.22283 3.62958 6.17178 3.65124 6.11816 3.65125Z" fill="#ECF0F3" stroke="#ECF0F3"/>
            <path d="M6.11719 9.76874L6.11719 5.27481L6.11719 9.76874Z" fill="#ECF0F3"/>
            <path d="M6.11719 9.76874L6.11719 5.27481" stroke="#ECF0F3" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>

          <span class="ml-1">Iniciar tutorial de uso</span>
        </button>
      </section>

      <section class="float-left d-flex">
        <b-overlay
          v-if="!importedCompany && releaseFreeMode(user) && checkedlimitation()"
          :show='false'
          rounded
          opacity='0.6'
          spinner-small
          spinner-variant='primary'
          class='d-inline-block mt-2'
        >
          <button
            @click="showFispqUploadAndRegisterChemicalAgentsModal()"
            class='btn-mode '
          >
            <span  class='text-filter pr-2 px-2'>Cadastrar agentes</span>
          </button>
        </b-overlay>

        <section v-if="releaseCompanyMode(user)" class=' py-1 d-flex'>
          <b-overlay
            v-if="importedCompany && tabView === 'Summary'"
            :show='false'
            rounded
            opacity='0.6'
            spinner-small
            spinner-variant='primary'
            class='d-inline-block mt-1'
          >
            <button
              @click="showFispqUploadAndReadModal()"
              class='btn-mode d-flex align-items-center justify-content-center pr-1'
            >
              <span  class='text-filter pr-2 px-2'>Cadastrar novo produto com IA</span>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_7411_5440)">
                  <path d="M22.8034 9.35L20.5034 7.45V3.75C20.5018 3.65412 20.4726 3.56072 20.4194 3.48094C20.3663 3.40115 20.2912 3.33834 20.2034 3.3L15.2534 1.05H15.0534L14.7534 1.15L12.0034 2.95L9.25335 1.1L8.95335 1H8.75335L3.80335 3.3C3.71546 3.33834 3.64045 3.40115 3.58726 3.48094C3.53407 3.56072 3.50494 3.65412 3.50335 3.75V7.45L1.20335 9.35C1.13397 9.38917 1.07786 9.44817 1.04223 9.51944C1.0066 9.5907 0.993059 9.67099 1.00335 9.75V14.25C0.993059 14.329 1.0066 14.4093 1.04223 14.4806C1.07786 14.5518 1.13397 14.6108 1.20335 14.65L3.50335 16.55V20.25C3.50494 20.3459 3.53407 20.4393 3.58726 20.5191C3.64045 20.5988 3.71546 20.6617 3.80335 20.7L8.75335 22.95H8.95335L9.25335 22.85L12.0034 21.05L14.7534 22.9L15.0534 23H15.2534L20.2034 20.75C20.2912 20.7117 20.3663 20.6488 20.4194 20.5691C20.4726 20.4893 20.5018 20.3959 20.5034 20.3V16.55L22.8034 14.65C22.8647 14.6146 22.9155 14.5635 22.9507 14.502C22.9858 14.4405 23.004 14.3708 23.0034 14.3V9.7C23.004 9.62918 22.9858 9.55946 22.9507 9.49796C22.9155 9.43647 22.8647 9.38541 22.8034 9.35ZM20.2534 12.75H21.0034V13.55L19.2534 14.95L19.0534 15.1L18.8534 15C18.7662 14.9499 18.6693 14.9192 18.5692 14.9099C18.4691 14.9006 18.3682 14.913 18.2733 14.9462C18.1784 14.9794 18.0918 15.0327 18.0193 15.1023C17.9468 15.172 17.8902 15.2565 17.8534 15.35C17.7636 15.523 17.7448 15.7241 17.8008 15.9108C17.8568 16.0974 17.9832 16.255 18.1534 16.35L18.5034 16.5V19.2L15.2034 20.75L13.1034 19.35L12.7534 19.1V12.75H13.5034C13.7023 12.75 13.893 12.671 14.0337 12.5303C14.1743 12.3897 14.2534 12.1989 14.2534 12C14.2534 11.8011 14.1743 11.6103 14.0337 11.4697C13.893 11.329 13.7023 11.25 13.5034 11.25H12.7534V4.85L13.1034 4.6L15.2034 3.2L18.5034 4.75V7.45L18.1534 7.6C17.9832 7.69505 17.8568 7.85258 17.8008 8.03923C17.7448 8.22588 17.7636 8.427 17.8534 8.6C17.9037 8.73177 17.9928 8.84524 18.1087 8.92554C18.2247 9.00585 18.3623 9.04923 18.5034 9.05L18.8534 8.95L19.0534 8.85L19.2534 9L21.0034 10.45V11.25H20.2534C20.0544 11.25 19.8637 11.329 19.723 11.4697C19.5824 11.6103 19.5034 11.8011 19.5034 12C19.5034 12.1989 19.5824 12.3897 19.723 12.5303C19.8637 12.671 20.0544 12.75 20.2534 12.75ZM10.5034 12.75H11.2534V19.15L10.9034 19.4L8.80335 20.8L5.50335 19.25V16.55L5.85335 16.4C6.02347 16.305 6.14992 16.1474 6.20592 15.9608C6.26191 15.7741 6.24306 15.573 6.15335 15.4C6.11646 15.3065 6.05986 15.222 5.9874 15.1523C5.91494 15.0827 5.82832 15.0294 5.73344 14.9962C5.63855 14.963 5.53763 14.9506 5.43753 14.9599C5.33743 14.9692 5.24051 14.9999 5.15335 15.05L4.95335 15.15L4.75335 15L3.00335 13.55V12.75H3.75335C3.95226 12.75 4.14303 12.671 4.28368 12.5303C4.42433 12.3897 4.50335 12.1989 4.50335 12C4.50335 11.8011 4.42433 11.6103 4.28368 11.4697C4.14303 11.329 3.95226 11.25 3.75335 11.25H3.00335V10.45L4.75335 9.05L4.95335 8.9L5.15335 9L5.50335 9.1C5.64442 9.09923 5.78197 9.05585 5.89796 8.97554C6.01395 8.89524 6.10297 8.78177 6.15335 8.65C6.24306 8.477 6.26191 8.27588 6.20592 8.08923C6.14992 7.90258 6.02347 7.74505 5.85335 7.65L5.50335 7.5V4.75L8.80335 3.2L10.9034 4.6L11.2534 4.85V11.25H10.5034C10.3044 11.25 10.1137 11.329 9.97302 11.4697C9.83237 11.6103 9.75335 11.8011 9.75335 12C9.75335 12.1989 9.83237 12.3897 9.97302 12.5303C10.1137 12.671 10.3044 12.75 10.5034 12.75Z" fill="#022245"/>
                  <path d="M6.95 4.95006C6.82837 5.10761 6.76239 5.30103 6.76239 5.50006C6.76239 5.6991 6.82837 5.89252 6.95 6.05006L8.25 7.30006V8.70006L6.25 10.7001V13.3001L8.25 15.3001V16.7001L6.95 17.9501C6.82837 18.1076 6.76239 18.301 6.76239 18.5001C6.76239 18.6991 6.82837 18.8925 6.95 19.0501C7.02359 19.1186 7.1102 19.1716 7.20469 19.2059C7.29917 19.2403 7.3996 19.2553 7.5 19.2501C7.6004 19.2553 7.70083 19.2403 7.79531 19.2059C7.8898 19.1716 7.97641 19.1186 8.05 19.0501L9.75 17.3001V14.7001L7.75 12.7001V11.3001L9.75 9.30006V6.70006L8.05 4.95006C7.89246 4.82843 7.69903 4.76245 7.5 4.76245C7.30097 4.76245 7.10754 4.82843 6.95 4.95006Z" fill="#022245"/>
                  <path d="M15.75 7.30006L17.05 6.05006C17.1716 5.89252 17.2376 5.6991 17.2376 5.50006C17.2376 5.30103 17.1716 5.10761 17.05 4.95006C16.8925 4.82843 16.699 4.76245 16.5 4.76245C16.301 4.76245 16.1075 4.82843 15.95 4.95006L14.25 6.70006V9.30006L16.25 11.3001V12.7001L14.25 14.7001V17.3001L15.95 19.0501C16.1036 19.1804 16.2985 19.252 16.5 19.252C16.7015 19.252 16.8964 19.1804 17.05 19.0501C17.1716 18.8925 17.2376 18.6991 17.2376 18.5001C17.2376 18.301 17.1716 18.1076 17.05 17.9501L15.75 16.7001V15.3001L17.75 13.3001V10.7001L15.75 8.70006V7.30006Z" fill="#022245"/>
                </g>
                <defs>
                  <clipPath id="clip0_7411_5440">
                    <rect width="24" height="24" fill="white"/>
                  </clipPath>
                </defs>
              </svg>

            </button>
          </b-overlay>
          <section
            v-if='importedCompany'
            class='mt-1'
          >
            <b-overlay
              :show='loading'
              rounded
              opacity='0.6'
              spinner-small
              spinner-variant='primary'
              class='d-inline-block'
            >
              <button
                class='btn-mode'
                @click="showModalChangeMode()"
               >
                <span  class='text-filter pr-2 px-2'>Consulta em modo empresa: {{importedCompany.name}}</span>
              </button>
            </b-overlay>
          </section>

          <section v-else class='mt-1'>
            <b-overlay
              :show='loading'
              rounded
              opacity='0.6'
              spinner-small
              spinner-variant='primary'
              class='d-inline-block'
            >
              <button
                class='btn-mode'
                @click="switchToBusinessMode()"
              >
                <span class='text-filter pr-2 px-2'>Consulta em modo: <strong>Livre</strong></span>
              </button>
            </b-overlay>
          </section>
        </section>


      </section>
    </section>
  </section>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import eventBus from '@/utils/eventBus'
import { normalize } from '@/utils/regex'
import { releaseCompanyMode, releaseFreeMode } from '@/utils/releaseEnterpriseModeFunctionality'
import ModalConfirmAction from '@/components/ModalConfirmAction.vue'
import ModalTabVideos from '@/components/InstructionalVideos/components/ModalTabVideos.vue'
import FispqUploadAndReadModal from '@/components/LegalSearch/Modal/FispqUploadAndReadModal.vue'
import FispqUploadAndRegisterChemicalAgentsModal
  from '@/components/LegalSearch/Modal/FispqUploadAndRegisterChemicalAgentsModal.vue'

export default {
  name: 'FilterAgentsLegalConsultation',
  components: { FispqUploadAndRegisterChemicalAgentsModal, ModalTabVideos, FispqUploadAndReadModal, ModalConfirmAction },
  props: {},
  data() {
    return {
      instructionalVideos: [],
      selectAll: false,
      description: '',
      products: [],
      selectedProducts: [],
      title: '',
      loading: false,
      loadingConfirmation: false,
      acgih: [],
      nr15: [],
      linach: [],
      esocial: [],
      decreto: [],
      acgihAccumulateddFilter: [],
      nr15AccumulatedFilter: [],
      linachAccumulatedFilter: [],
      esocialAccumulatedFilter: [],
      decretoAccumulatedFilter: [],
      filterForwardedAgentsSelected: [],
      selectedAgentsFilter: [],
      agentSearchTerm: '',
      filters: {
        acgih: [],
        nr15: [],
        linach: [],
        esocial: [],
        decreto: [],
        typeFilterAgents: 'ACCUMULATED_FILTER',
      },
      filterProduct: false,
      filterNormativa: false,
      filterForwardedAgents: false,
      filterByAgent: false,
      accumulatedFilter: 'ACCUMULATED_FILTER',
      sequencedFilter: 'SEQUENCED_FILTER',
      heightFilter: 24,
    }
  },
  computed: {
    tabView() {
      return this.$store.getters['legalSearch/tabView']
    },
    appliedFilters() {
      return this.$store.getters['legalSearch/appliedFilters']
    },
    lookingForAgents() {
      return this.$store.getters['legalSearch/lookingForAgents']
    },
    summaryMeta() {
      return this.$store.getters['legalSearch/summaryMeta']
    },
    agentsName() {
      return this.$store.getters['legalSearch/agentsName']
    },
    selectedAgents() {
      return this.agentsName.filter((agent) => this.selectedAgentsFilter.includes(agent._id))
    },
    filteredAgentsName() {
      const term = this.sanitizeSearch(this.agentSearchTerm)
      if (!term) {
        return this.agentsName
      }
      return this.agentsName.filter((agent) => this.sanitizeSearch(agent.name).includes(term))
    },
    appliedAgentsNames() {
      const agents = this.summaryMeta.agents
      if (!agents || agents.length <= 0) {
        return ''
      }
      return this.agentsName
        .filter((agent) => agents.includes(agent._id))
        .map((agent) => agent.name)
        .join(', ')
    },
    user() {
      return this.$store.getters['user/current']
    },
    ...mapGetters('companyLegalConsultation', {
      importedCompany: 'importedCompany'
    }),
    ...mapGetters('breadcrumb', {
      breadcrumb: 'getBreadcrumb'
    }),
    filtroNormativoSelecionado(){
      return (this.acgihAccumulateddFilter && this.acgihAccumulateddFilter.length > 0) ||
              (this.nr15AccumulatedFilter && this.nr15AccumulatedFilter.length > 0) ||
              (this.linachAccumulatedFilter && this.linachAccumulatedFilter.length > 0) ||
              (this.esocialAccumulatedFilter && this.esocialAccumulatedFilter.length > 0) ||
              (this.decretoAccumulatedFilter && this.decretoAccumulatedFilter.length > 0) ||
              (this.acgih && this.acgih.length > 0) ||
              (this.nr15 && this.nr15.length > 0) ||
              (this.linach && this.linach.length > 0) ||
              (this.esocial && this.esocial.length > 0) ||
              (this.decreto && this.decreto.length > 0)
    },
    mostrarFiltroNormativoSelecionado(){
      if(this.filters.typeFilterAgents === this.accumulatedFilter){
        return (this.acgihAccumulateddFilter && this.acgihAccumulateddFilter.length > 0) ||
          (this.nr15AccumulatedFilter && this.nr15AccumulatedFilter.length > 0) ||
          (this.linachAccumulatedFilter && this.linachAccumulatedFilter.length > 0) ||
          (this.esocialAccumulatedFilter && this.esocialAccumulatedFilter.length > 0) ||
          (this.decretoAccumulatedFilter && this.decretoAccumulatedFilter.length > 0)
      }
      return (this.acgih && this.acgih.length > 0) ||
              (this.nr15 && this.nr15.length > 0) ||
              (this.linach && this.linach.length > 0) ||
              (this.esocial && this.esocial.length > 0) ||
              (this.decreto && this.decreto.length > 0)
    },
    ...mapGetters('instructionalVideo', {
      instructionalVideosByTab: 'instructionalVideosByTab'
    }),
    ...mapGetters('userPlans', {
      limitationOfAgentsAdded: 'limitationOfAgentsAdded'
    })
  },
  watch:{
    selectedProducts(){
      this.selectAll = this.selectedProducts.length == this.products.length
    },
    summaryMeta(){
      this.updateHeightFilter()
    },
    lookingForAgents(){
      this.updateHeightFilter()
    },
  },
  async mounted() {
    if (this.importedCompany && this.importedCompany._id) {
      const { data } = await this.handleGetProductLegalConsultationByCompany(this.importedCompany._id)
      const { products } = data
      this.products = products
      if (this.products && this.products.length > 0) {
        this.products.push({
          _id: '000f191e810c19729de860ea',
          name: "Mostrar agentes sem produtos"
        })
      }
    }
    if (this.user && this.user.id) {
      await this.handleGetAgentsName(this.user.id)
    }
    this.updateHeightFilter()
  },
  methods: {
    releaseFreeMode,
    releaseCompanyMode,
    ...mapActions('legalSearch', {
      handleResetSummaryMeta: 'handleResetSummaryMeta',
      setSkip: 'setSkip',
      summaryClear: 'summaryClear',
      handleSetSummaryMeta: 'handleSetSummaryMeta',
      importFreeModeAgents: 'importFreeModeAgents',
      handleGetAgentsName: 'handleGetAgentsName',
      handleGetLoadAgentsByRisk: 'handleGetLoadAgentsByRisk',
    }),
    ...mapActions('companyLegalConsultation', {
      handleGetNumberRegisteredCompanies: 'handleGetNumberRegisteredCompanies',
      handleUnmarkAllAsLastImportedCompanyLegalConsultation: 'handleUnmarkAllAsLastImportedCompanyLegalConsultation',
      handleGetLastImportedCompanyLegalConsultation: 'handleGetLastImportedCompanyLegalConsultation',
    }),
    ...mapActions('productLegalConsultation', {
      handleGetProductLegalConsultationByCompany: 'handleGetProductLegalConsultationByCompany',
    }),
    ...mapActions('instructionalVideo', {
      handleGetByTab: 'handleGetByTab'
    }),
    checkedlimitation(){
      const plansAccess = ['AN1HO', 'PROMO', 'OUTRO', 'COPY', 'PROMO2']
      const {plan: userPlan, role} = this.user || {}
      if(role && role === 'admin'){
        return true
      }

      const {plan} = userPlan || {}
      if (!plan || plan === 'TRIAL') {
        return false
      }

      if (plansAccess.includes(plan)){
        return true
      }

      const {added, limitation, plan: planLimitation } = this.limitationOfAgentsAdded || {}

      if(!planLimitation){
        return false
      }

      return added < limitation;
    },

    showModalTabVideos(){
      setTimeout(() => {
        this.$refs.modalTabVideosSideBar.init()
      },100)
    },
    updateHeightFilter(){
      const element = document.getElementById('filters')
      this.heightFilter = element && element.clientHeight ? element.clientHeight : 24
    },
    setTypeFilterAgents(typeFilterAgents){
      this.filters.typeFilterAgents = typeFilterAgents
    },
    setSelectAll(select){
      this.selectedProducts = []
      if (select) {
        this.selectedProducts = this.products.map(x => x._id)
      }
    },
    sanitizeSearch(value) {
      return normalize(value).replace(/[^a-z0-9]/g, '')
    },
    async showModalChangeMode() {
      try {
        this.$bvModal.show('changeMode')
        this.title = 'Alterar modo de consulta';
        this.description = 'Deseja realmente alterar para o modo de consulta livre?';
      } catch (e) {

      }
    },

    async showFispqUploadAndReadModal() {
      try {
        this.$bvModal.show('fispqUploadAndReadModal')
      } catch (e) {

      }
    },

    async showFispqUploadAndRegisterChemicalAgentsModal() {
      try {
        this.$bvModal.show('fispqUploadAndRegisterChemicalAgentsModal')
      } catch (e) {

      }
    },

    async setImportedToFalseCompanyLegalConsultation() {
      try {
        this.loading = true;
        await this.handleUnmarkAllAsLastImportedCompanyLegalConsultation(this.user.id)
        await this.handleGetLastImportedCompanyLegalConsultation(this.user.id)
        await this.importFreeModeAgents(this.user.id)
        this.loading = false;
        await this.load()
        await this.handleGetLoadAgentsByRisk({userId: this.user.id })
        this.$bvToast.toast(`Modo de consulta alterado para modo livre.`, {
          title: 'Atenção',
          variant: 'success',
          toaster: 'b-toaster-top-center',
          autoHideDelay: 6000,
        });
        this.$bvModal.hide('changeMode')
      } catch (e) {

      }
    },

    async switchToBusinessMode() {
      try {
        this.loading = true;
        const amount = await this.handleGetNumberRegisteredCompanies(this.user.id)
        if (amount > 0) {
          this.$bvModal.show('registerProductOrImport')
        } else{
          this.$bvModal.show('company')
        }
        this.loading = false;
      } catch (e) {

      }
    },

    callGlobalCustomEvent(event, body) {
      eventBus.$emit(event, body)
    },

    updateSelectedFilter(variable, value) {
      const length = this[variable].length
      if (length > 1) {
        this[variable] = [value]
      }
    },

    updateFilterForwardedAgentsSelected(variable, value) {
      const length = this[variable].length
      if (length > 1) {
        this[variable] = [value]
      }
    },

    async showModal() {
      const { agents, acgih, nr15, linach, esocial, decreto, products, filterForwardedAgents, typeFilterAgents } = this.summaryMeta

      this.selectedProducts = products ? products : []
      this.filters.typeFilterAgents = typeFilterAgents ? typeFilterAgents : this.accumulatedFilter
      this.filterForwardedAgentsSelected = filterForwardedAgents ? [filterForwardedAgents] : []
      this.selectedAgentsFilter = agents ? agents : []
      this.agentSearchTerm = ''

      if (this.user && this.user.id) {
        await this.handleGetAgentsName(this.user.id)
      }

      this.acgih = []
      this.nr15 = []
      this.linach = []
      this.esocial = []
      this.decreto = []

      this.acgihAccumulateddFilter = []
      this.nr15AccumulatedFilter = []
      this.linachAccumulatedFilter = []
      this.esocialAccumulatedFilter = []
      this.decretoAccumulatedFilter = []


      if (this.filters.typeFilterAgents === this.accumulatedFilter) {
        this.acgihAccumulateddFilter = acgih
        this.nr15AccumulatedFilter = nr15
        this.linachAccumulatedFilter = linach
        this.esocialAccumulatedFilter = esocial
        this.decretoAccumulatedFilter = decreto
      } else {
        this.acgih = acgih
        this.nr15 = nr15
        this.linach = linach
        this.esocial = esocial
        this.decreto = decreto
      }

      if (this.importedCompany && this.importedCompany._id) {
        const { data } = await this.handleGetProductLegalConsultationByCompany(this.importedCompany._id)
        const {products} = data
        this.products = products
        if(this.products && this.products.length > 0) {
          this.products.push({
            _id: '000f191e810c19729de860ea',
            name: "Mostrar agentes sem produtos"
          })
        }
      }
      this.selectAll = this.selectedProducts.length === this.products.length
      if(this.filterForwardedAgentsSelected.length === 0) {
        this.filterForwardedAgentsSelected = ['SHOW_ALL']
      }


    },

    showModalFilter() {
      this.$refs.filter.show()
    },

    closeModal() {
      this.$refs.filter.hide()
    },

    async showModalConfirmation() {
      this.$refs['filter-confirmation'].show()
    },

    closeModalConfirmation() {
      this.$refs['filter-confirmation'].hide()
    },

    async searchAgents() {
      await this.setSkip(1)
      await this.summaryClear()
      this.loadingConfirmation =  true
      let body = {
        agents: this.selectedAgentsFilter,
        acgih: this.acgih,
        nr15: this.nr15,
        linach: this.linach,
        esocial: this.esocial,
        decreto: this.decreto,
        products: this.selectedProducts,
        typeFilterAgents: this.filters.typeFilterAgents,
        filterForwardedAgents: this.filterForwardedAgentsSelected.toString()
      }
      if(this.filters.typeFilterAgents === this.accumulatedFilter){
        body = {
          agents: this.selectedAgentsFilter,
          acgih: this.acgihAccumulateddFilter,
          nr15: this.nr15AccumulatedFilter,
          linach: this.linachAccumulatedFilter,
          esocial: this.esocialAccumulatedFilter,
          decreto: this.decretoAccumulatedFilter,
          products: this.selectedProducts,
          typeFilterAgents: this.filters.typeFilterAgents,
          filterForwardedAgents: this.filterForwardedAgentsSelected.toString()
        }
      }

      await this.handleSetSummaryMeta(body)
      await this.load()
      this.loadingConfirmation =  false
      this.$refs['filter-confirmation'].hide()
      this.$refs.filter.hide()
      this.updateHeightFilter()
      eventBus.$emit('reloadLegalSearchReportTabs')
    },

    async load() {
      this.loading = false
      await this.$store.dispatch('legalSearch/load', this.user.id)
    },

    async clearSelectedFilters() {
      this.selectedAgentsFilter = []
      await this.summaryClear()
      await this.setSkip(1)
      this.$refs.filter.hide()
      await this.handleResetSummaryMeta()
      await this.load()
      eventBus.$emit('reloadLegalSearchReportTabs')
    }
  }
}
</script>
<style>
.custom-tooltip-applied-filters > .tooltip-inner {
  max-width:1000px !important;
  width: 1000px !important;
}
.popover {
  max-width:1000px !important;
}
</style>
<style lang='scss' scoped>
.rotate {
  transform: rotate(90deg);
  -ms-transform: rotate(90deg);
  -webkit-transform: rotate(90deg);

}
.transition {
  -webkit-transition: -webkit-transform .5s ease-in-out;
  -ms-transition: -ms-transform .5s ease-in-out;
  transform: translateY(0) scale(1);
}

.header{
  .title{
    font-size: 20px;
    font-weight: 700;
    line-height: 29.26px;
    text-align: left;
    color: #262626;

  }
}
.warning{
  background: #04A8F366;
  border-radius: 8px;
  font-size: 15px;
  font-weight: 400;
  line-height: 18px;
  color: #022245;
}

.filter-product {
  border: 1px solid #808080;
  border-radius: 4px;
  .title-product{
    font-size: 18px;
    font-weight: 600;
    text-align: left;
    color: #262626;
  }
  .title-quantity-product{
    font-size: 15px;
    font-weight: 400;
    text-align: left;
    color: #262626;
  }
  .selected-products{
    font-weight: 400;
    text-align: left;
    color: #262626;
  }
  .product {
    border-radius: 7px;
    padding: 10px;
    border: 1.5px solid #808080;
  }
}
.text{
  font-size: 14px;
  font-weight: 400;
  text-align: left;
}
h6{
  font-size: 15px;
  font-weight: 600;
  line-height: 19.5px;
  text-align: left;
  color: #3F444D;
}
.text-opcoes-relavao-legal{
  font-size: 14px;
  font-weight: 400;
  text-align: left;
  color: #3F444D;
}

.filter-content {
  border-radius: 4px;
  border: 1px solid #85D1F3;
  background: #DBECF4;
  min-height: 50px !important;
  max-height: 55px;
  overflow-y : hidden;
  overflow-x : hidden;
  .btn-filtros {
    text-decoration: none;
    cursor: pointer;
  }
  .text-btn-filtros {
    color: #022245;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }
}
.filter-content::-webkit-scrollbar {
  width: 12px; /* width of the entire scrollbar */
}

.filter-content::-webkit-scrollbar-track {
  background: #ffffff;
}

.filter-content::-webkit-scrollbar-thumb {
  background: #022245; /* color of the scroll thumb */
  border-radius: 20px; /* roundness of the scroll thumb */
  border: 3px solid #ffffff; /* creates padding around scroll thumb */
  -webkit-box-shadow: inset 0 0 6px #022245;
  height: 40px;
}
.btn-clear-filter {
  background: transparent !important;
  border-radius: 6.25px !important;
  border: 1px solid var(--navy-blue) !important;

  span {
    color: var(--navy-blue);
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
  }
}
.text-filter {
  color: #022245;
  font-style: normal;
  font-weight: 700;
  font-size: 15px;
  line-height: normal;
}

.btn-new-filter {
  border-radius: 4px;
  border: 1px solid #85D1F3;
  background: #DBECF4;
  min-height: 40px !important;
}
.btn-mode {
  border-radius: 4px;
  border: 1px solid  #CBD63E;
  background: rgba(203, 214, 62, 0.40);
  min-height: 40px !important;
  width: max-content;
  margin-left: 10px;
}

.btn_filter {
  background: var(--navy-blue) !important;
  border-radius: 6.25px !important;
  border: 1px solid var(--navy-blue) !important;

  span {
    color: #ffffff;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
  }
}

.divider {
  width: 1px !important;
  background: #FFFFFF !important;
  height: 100% !important;
}

.text-filter-applied {
  color: #022245;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  font-size: 15px;
}

.filter-normativas{
  border: 1px solid #808080;
  border-radius: 4px;
}


.btn-selected{
  border: 1px solid #04A8F3;
  background: #CBD63E;
  font-weight: 700;
  font-size: 14px;
  text-align: center;
  border-radius: 6px;
  padding: 8px;

}
.btn-not-selected{
  border: 1px solid #04A8F3;
  background: transparent;
  font-weight: 700;
  font-size: 14px;
  text-align: center;
  border-radius: 6px;
  padding: 8px;
  color: #04A8F3
}

.filter-forwarded-agents{
  border: 1px solid #808080;
  border-radius: 4px;
  .title {
    font-weight: 700;
    font-size: 18px;
    color: #262626;
  }
  .observations{
    font-family: Montserrat;
    font-weight: 400;
    font-size: 16px;
    color: #262626;
  }

  .sub-title {
    font-size: 15px;
    font-weight: 400;
    color: #262626;
  }
  .checkbox-item{
    border: 1px solid #808080;
    padding: 10px;
    border-radius: 8px;
  }
  .agents-list{
    max-height: 320px;
    overflow-y: auto;
    padding-right: 6px;
    .product {
      border-radius: 7px;
      padding: 10px;
      border: 1.5px solid #808080;
    }
  }
  .selected-agents-list{
    list-style: disc;
    margin: 0;
    padding: 10px 10px 10px 28px;
    max-height: 180px;
    overflow-y: auto;
    border: 1px solid #808080;
    border-radius: 4px;
    column-gap: 24px;
    columns: 2;
    li{
      break-inside: avoid;
      font-size: 14px;
      color: #262626;
      margin-bottom: 4px;
    }
  }
}

.btn-video {
  background-color: #CBD63E;
  color: #022245;
  font-weight: 600;
  font-size: 15px;
  border: none;
  padding: 5px;
  border-radius: 3px;
}
</style>
